/* This file is auto-generated, manual edits in this file will be overwritten! */

export const i18nKeys = {
  CONFIRMED: 'CONFIRMED',
  a11y: {
    ariaLabel: {
      menu: 'a11y.ariaLabel.menu',
    },
  },
  activityAgreement: {
    DISABLEDPERSONTRANSPORTATION: {
      subtitle: 'activityAgreement.DISABLEDPERSONTRANSPORTATION.subtitle',
      title: 'activityAgreement.DISABLEDPERSONTRANSPORTATION.title',
    },
    GROCERYSHOPPING: {
      subtitle: 'activityAgreement.GROCERYSHOPPING.subtitle',
      title: 'activityAgreement.GROCERYSHOPPING.title',
    },
    HOUSEKEEPING: {
      subtitle: 'activityAgreement.HOUSEKEEPING.subtitle',
      title: 'activityAgreement.HOUSEKEEPING.title',
    },
    IRONING: {
      subtitle: 'activityAgreement.IRONING.subtitle',
      title: 'activityAgreement.IRONING.title',
    },
    currentAgreement: {
      title: 'activityAgreement.currentAgreement.title',
    },
    details: {
      issueDate: 'activityAgreement.details.issueDate',
      status: 'activityAgreement.details.status',
      suspensionDate: 'activityAgreement.details.suspensionDate',
      withdrawalDate: 'activityAgreement.details.withdrawalDate',
    },
    status: {
      ACTIVE: 'activityAgreement.status.ACTIVE',
      SUSPENDED: 'activityAgreement.status.SUSPENDED',
      WITHDRAWN: 'activityAgreement.status.WITHDRAWN',
    },
    title: 'activityAgreement.title',
  },
  bl: {
    brps: {
      label: 'bl.brps.label',
      url: 'bl.brps.url',
    },
    general: {
      emailAddress: 'bl.general.emailAddress',
      helpCenter: {
        phone: 'bl.general.helpCenter.phone',
      },
      region: {
        name: 'bl.general.region.name',
      },
      serviceVouchers: {
        helpCenter: {
          phoneNumber: 'bl.general.serviceVouchers.helpCenter.phoneNumber',
        },
        website: {
          url: 'bl.general.serviceVouchers.website.url',
        },
      },
      url: {
        complaint: 'bl.general.url.complaint',
        contactUs: 'bl.general.url.contactUs',
        cookies: 'bl.general.url.cookies',
        faq: 'bl.general.url.faq',
        news: 'bl.general.url.news',
        privacyPolicy: 'bl.general.url.privacyPolicy',
        question: 'bl.general.url.question',
        termsAndConditions: 'bl.general.url.termsAndConditions',
        accountFrozenBlocked: 'bl.general.url.accountFrozenBlocked',
      },
    },
    header: {
      support: {
        contactList: {
          callus: {
            description: 'bl.header.support.contactList.callus.description',
          },
        },
      },
    },
    login: {
      cta: {
        register: 'bl.login.cta.register',
      },
      title: {
        notRegisterYet: 'bl.login.title.notRegisterYet',
      },
    },
    remittances: {
      reimbursement: {
        pdf: 'bl.remittances.reimbursement.pdf',
      },
    },
    siteBar: {
      title: 'bl.siteBar.title',
    },
  },
  brussels: {
    footer: {
      title: 'brussels.footer.title',
    },
    header: {
      regionName: 'brussels.header.regionName',
    },
  },
  contact: {
    alert: {
      body: 'contact.alert.body',
      title: 'contact.alert.title',
    },
    headquarterContactInformationTitle:
      'contact.headquarterContactInformationTitle',
    saveContactPerson: 'contact.saveContactPerson',
    yourContactPerson: 'contact.yourContactPerson',
  },
  contactPersons: {
    alert: {
      delete: 'contactPersons.alert.delete',
      description: 'contactPersons.alert.description',
      title: 'contactPersons.alert.title',
    },
    cta: {
      add: 'contactPersons.cta.add',
      remove: 'contactPersons.cta.remove',
    },
    details: {
      edit: {
        errorMessage: 'contactPersons.details.edit.errorMessage',
        successMessage: 'contactPersons.details.edit.successMessage',
        sucessLink: 'contactPersons.details.edit.sucessLink',
      },
    },
    mainContactPerson: {
      title: 'contactPersons.mainContactPerson.title',
    },
    modal: {
      add: {
        errorMessage: 'contactPersons.modal.add.errorMessage',
        submit: 'contactPersons.modal.add.submit',
        successLink: 'contactPersons.modal.add.successLink',
        successMessage: 'contactPersons.modal.add.successMessage',
      },
      addContactPerson: {
        title: 'contactPersons.modal.addContactPerson.title',
      },
    },
    otherContactPerson: {
      title: 'contactPersons.otherContactPerson.title',
    },
    title: 'contactPersons.title',
  },
  contract: {
    modal: {
      addContract: {
        form: {
          label: {
            contractType: 'contract.modal.addContract.form.label.contractType',
            period: 'contract.modal.addContract.form.label.period',
            unitNumber: 'contract.modal.addContract.form.label.unitNumber',
            workStatus: 'contract.modal.addContract.form.label.workStatus',
          },
        },
        title: 'contract.modal.addContract.title',
        tooltips: {
          unitNumber: 'contract.modal.addContract.tooltips.unitNumber',
        },
      },
      deleteContract: {
        cta: 'contract.modal.deleteContract.cta',
        title: 'contract.modal.deleteContract.title',
      },
      editContract: {
        cta: 'contract.modal.editContract.cta',
        title: 'contract.modal.editContract.title',
      },
    },
  },
  dashboard: {
    actions: {
      financialContact: {
        description: 'dashboard.actions.financialContact.description',
        title: 'dashboard.actions.financialContact.title',
      },
      nothingToDo: 'dashboard.actions.nothingToDo',
      remittances: {
        incorrect: 'dashboard.actions.remittances.incorrect',
        refused: 'dashboard.actions.remittances.refused',
        single: {
          incorrect: 'dashboard.actions.remittances.single.incorrect',
          refused: 'dashboard.actions.remittances.single.refused',
        },
        title: 'dashboard.actions.remittances.title',
      },
      title: 'dashboard.actions.title',
      workers: {
        missingContract: 'dashboard.actions.workers.missingContract',
        needResetPassword: 'dashboard.actions.workers.needResetPassword',
        title: 'dashboard.actions.workers.title',
      },
      works: {
        aboutToExpire: 'dashboard.actions.works.aboutToExpire',
        contested: 'dashboard.actions.works.contested',
        title: 'dashboard.actions.works.title',
        waitingForValidation: 'dashboard.actions.works.waitingForValidation',
      },
    },
    introduction: 'dashboard.introduction',
    introductionNew: 'dashboard.introductionNew',
    noActions: {
      title: 'dashboard.noActions.title',
    },
    overview: {
      pickup: {
        cta: {
          createPickup: 'dashboard.overview.pickup.cta.createPickup',
          seePickups: 'dashboard.overview.pickup.cta.seePickups',
        },
        nextScheduled: 'dashboard.overview.pickup.nextScheduled',
        noPickupPlanned: 'dashboard.overview.pickup.noPickupPlanned',
        title: 'dashboard.overview.pickup.title',
        typeOfPickup: 'dashboard.overview.pickup.typeOfPickup',
      },
      remittances: {
        incorrect: 'dashboard.overview.remittances.incorrect',
        refunded: 'dashboard.overview.remittances.refunded',
        refused: 'dashboard.overview.remittances.refused',
        title: 'dashboard.overview.remittances.title',
      },
      title: 'dashboard.overview.title',
      works: {
        contested: 'dashboard.overview.works.contested',
        title: 'dashboard.overview.works.title',
        validated: 'dashboard.overview.works.validated',
        waitingRemittance: 'dashboard.overview.works.waitingRemittance',
      },
    },
    tips: {
      advice1: {
        subTitle: 'dashboard.tips.advice1.subTitle',
        title: 'dashboard.tips.advice1.title',
        url: {
          BE_BRU: 'dashboard.tips.advice1.url.BE_BRU',
          BE_VLG: 'dashboard.tips.advice1.url.BE_VLG',
          BE_WAL: 'dashboard.tips.advice1.url.BE_WAL',
        },
      },
      advice2: {
        subTitle: 'dashboard.tips.advice2.subTitle',
        title: 'dashboard.tips.advice2.title',
        url: {
          BE_BRU: 'dashboard.tips.advice2.url.BE_BRU',
          BE_VLG: 'dashboard.tips.advice2.url.BE_VLG',
          BE_WAL: 'dashboard.tips.advice2.url.BE_WAL',
        },
      },
      advice3: {
        subTitle: 'dashboard.tips.advice3.subTitle',
        title: 'dashboard.tips.advice3.title',
        url: {
          BE_BRU: 'dashboard.tips.advice3.url.BE_BRU',
          BE_VLG: 'dashboard.tips.advice3.url.BE_VLG',
          BE_WAL: 'dashboard.tips.advice3.url.BE_WAL',
        },
      },
      advice4: {
        cta: 'dashboard.tips.advice4.cta',
        subTitle: 'dashboard.tips.advice4.subTitle',
        title: 'dashboard.tips.advice4.title',
        url: {
          BE_BRU: 'dashboard.tips.advice4.url.BE_BRU',
          BE_VLG: 'dashboard.tips.advice4.url.BE_VLG',
          BE_WAL: 'dashboard.tips.advice4.url.BE_WAL',
        },
      },
      advice5: {
        cta: 'dashboard.tips.advice5.cta',
        subTitle: 'dashboard.tips.advice5.subTitle',
        title: 'dashboard.tips.advice5.title',
        url: {
          BE_BRU: 'dashboard.tips.advice5.url.BE_BRU',
          BE_VLG: 'dashboard.tips.advice5.url.BE_VLG',
          BE_WAL: 'dashboard.tips.advice5.url.BE_WAL',
        },
      },
      cta: 'dashboard.tips.cta',
      title: 'dashboard.tips.title',
    },
  },
  dialog: {
    confirmClose: {
      message: 'dialog.confirmClose.message',
    },
    signoutConfirm: {
      signout: {
        cta: 'dialog.signoutConfirm.signout.cta',
      },
      switch: {
        cta: 'dialog.signoutConfirm.switch.cta',
      },
      title: 'dialog.signoutConfirm.title',
    },
  },
  errors: {
    form: {
      autocomplete: {
        minLength: 'errors.form.autocomplete.minLength',
      },
      checked: 'errors.form.checked',
      date: {
        invalid: 'errors.form.date.invalid',
      },
      different: 'errors.form.different',
      differentPassword: 'errors.form.differentPassword',
      email: 'errors.form.email',
      equal: 'errors.form.equal',
      invalid: 'errors.form.invalid',
      maxLength: 'errors.form.maxLength',
      maxValue: 'errors.form.maxValue',
      minLength: 'errors.form.minLength',
      minValue: 'errors.form.minValue',
      mobilePhoneNumber: 'errors.form.mobilePhoneNumber',
      newPassword: 'errors.form.newPassword',
      newPasswordConfirm: 'errors.form.newPasswordConfirm',
      niss: {
        invalid: 'errors.form.niss.invalid',
      },
      noPaste: 'errors.form.noPaste',
      password: 'errors.form.password',
      required: 'errors.form.required',
      sequenceDates: 'errors.form.sequenceDates',
      voucherFormat: 'errors.form.voucherFormat',
      website: 'errors.form.website',
    },
    notFoundScreen: {
      cta: 'errors.notFoundScreen.cta',
      subTitle: 'errors.notFoundScreen.subTitle',
      title: 'errors.notFoundScreen.title',
    },
    server: {
      BUSINESS_SERVICE_ERROR: 'errors.server.BUSINESS_SERVICE_ERROR',
      CLIENT_NOT_AUTHENTICATED: 'errors.server.CLIENT_NOT_AUTHENTICATED',
      DEFAULT: 'errors.server.DEFAULT',
      ENTITY_NOT_FOUND: 'errors.server.ENTITY_NOT_FOUND',
      EXTERNAL_SERVICE_ERROR: 'errors.server.EXTERNAL_SERVICE_ERROR',
      INTERNAL_SERVER_ERROR: 'errors.server.INTERNAL_SERVER_ERROR',
      INVALID_FILE_FORMAT: 'errors.server.INVALID_FILE_FORMAT',
      INVALID_REQUEST_SYNTAX: 'errors.server.INVALID_REQUEST_SYNTAX',
      VALIDATION_EXCEPTION: 'errors.server.VALIDATION_EXCEPTION',
      business: {
        ACTIVITY_SUSPENDED: 'errors.server.business.ACTIVITY_SUSPENDED',
        APPROVAL_FOR_THIS_ACTIVITY_MISSING_IN_THIS_REGION:
          'errors.server.business.APPROVAL_FOR_THIS_ACTIVITY_MISSING_IN_THIS_REGION',
        APPROVAL_FOR_THIS_ACTIVITY_WAS_REVOKED_IN_THIS_REGION:
          'errors.server.business.APPROVAL_FOR_THIS_ACTIVITY_WAS_REVOKED_IN_THIS_REGION',
        AT_LEAST_ONE_PHONE_NUMBER_MUST_BE_FILLED:
          'errors.server.business.AT_LEAST_ONE_PHONE_NUMBER_MUST_BE_FILLED',
        AUTHORISATION_LOCKED: 'errors.server.business.AUTHORISATION_LOCKED',
        A_FILE_IMPORT_IS_ALREADY_IN_PROGRESS:
          'errors.server.business.A_FILE_IMPORT_IS_ALREADY_IN_PROGRESS',
        CANNOT_CREATE_A_PICKUP_FOR_NON_BUSINESS_DAY:
          'errors.server.business.CANNOT_CREATE_A_PICKUP_FOR_NON_BUSINESS_DAY',
        CANNOT_CREATE_SERVICE_APPLICATION_FOR_BLOCKED_CUSTOMER:
          'errors.server.business.CANNOT_CREATE_SERVICE_APPLICATION_FOR_BLOCKED_CUSTOMER',
        CANNOT_CREATE_SERVICE_APPLICATION_FOR_FROZEN_CUSTOMER:
          'errors.server.business.CANNOT_CREATE_SERVICE_APPLICATION_FOR_FROZEN_CUSTOMER',
        CANNOT_CREATE_SERVICE_APPLICATION_FOR_INACTIVE_WORKER:
          'errors.server.business.CANNOT_CREATE_SERVICE_APPLICATION_FOR_INACTIVE_WORKER',
        INVALID_CUSTOMER_ID: 'errors.server.business.INVALID_CUSTOMER_ID',
        INVALID_PROVIDER_ID: 'errors.server.business.INVALID_PROVIDER_ID',
        INVALID_WORKER_ID: 'errors.server.business.INVALID_WORKER_ID',
        MAXIMUM_NUMBER_OF_ACTIVE_PICKUP_RECURRENCES_REACHED:
          'errors.server.business.MAXIMUM_NUMBER_OF_ACTIVE_PICKUP_RECURRENCES_REACHED',
        ONLY_BILLS_FROM_2014_TO_THIS_YEAR_ARE_AVAILABLE:
          'errors.server.business.ONLY_BILLS_FROM_2014_TO_THIS_YEAR_ARE_AVAILABLE',
        ONLY_HEADQUARTERS_CAN_ACCESS_BILLING:
          'errors.server.business.ONLY_HEADQUARTERS_CAN_ACCESS_BILLING',
        PICKUP_ALREADY_PLANNED: 'errors.server.business.PICKUP_ALREADY_PLANNED',
        RECURRENT_PICKUP_ALREADY_PLANNED:
          'errors.server.business.RECURRENT_PICKUP_ALREADY_PLANNED',
        SERVICE_APPLICATION_ALREADY_EXISTS:
          'errors.server.business.SERVICE_APPLICATION_ALREADY_EXISTS',
        SVC_CRW002: 'errors.server.business.SVC_CRW002',
        SVC_CRW003: 'errors.server.business.SVC_CRW003',
        SVC_CRW007: 'errors.server.business.SVC_CRW007',
        SVC_CRW008: 'errors.server.business.SVC_CRW008',
        SVC_CRW012: 'errors.server.business.SVC_CRW012',
        SVC_CRW013: 'errors.server.business.SVC_CRW013',
        SVC_CRW014: 'errors.server.business.SVC_CRW014',
        WORKER_IS_NOT_ACTIVE: 'errors.server.business.WORKER_IS_NOT_ACTIVE',
        WORKER_NOT_FOUND_FOR_THIS_PROVIDER:
          'errors.server.business.WORKER_NOT_FOUND_FOR_THIS_PROVIDER',
      },
      form: {
        ACTIVITY_SUSPENDED: 'errors.server.form.ACTIVITY_SUSPENDED',
        CONTACT_SUPPORT: 'errors.server.form.CONTACT_SUPPORT',
        DATA_LIMIT_EXCEEDED: 'errors.server.form.DATA_LIMIT_EXCEEDED',
        DATE_IN_FUTURE: 'errors.server.form.DATE_IN_FUTURE',
        DATE_IN_PAST: 'errors.server.form.DATE_IN_PAST',
        DATE_TOO_OLD: 'errors.server.form.DATE_TOO_OLD',
        DEFAULT: 'errors.server.form.DEFAULT',
        INVALID: 'errors.server.form.INVALID',
        INVALID_FORMAT: 'errors.server.form.INVALID_FORMAT',
        MINIMUMAGENOTREACHED: 'errors.server.form.MINIMUMAGENOTREACHED',
        MISSING_VALUE: 'errors.server.form.MISSING_VALUE',
        NISS_MISMATCH: 'errors.server.form.NISS_MISMATCH',
        NOT_FOUND: 'errors.server.form.NOT_FOUND',
        NOT_REGISTERED: 'errors.server.form.NOT_REGISTERED',
        OUT_OF_ENUM: 'errors.server.form.OUT_OF_ENUM',
        PAPER_VOUCHER_ALREADY_ANNOUNCED:
          'errors.server.form.PAPER_VOUCHER_ALREADY_ANNOUNCED',
        PAPER_VOUCHER_ALREADY_IN_REMITTANCE:
          'errors.server.form.PAPER_VOUCHER_ALREADY_IN_REMITTANCE',
        PAPER_VOUCHER_BLACKLISTED:
          'errors.server.form.PAPER_VOUCHER_BLACKLISTED',
        PAPER_VOUCHER_CANCELLED: 'errors.server.form.PAPER_VOUCHER_CANCELLED',
        PAPER_VOUCHER_EXPIRED: 'errors.server.form.PAPER_VOUCHER_EXPIRED',
        PAPER_VOUCHER_LOST_OR_STOLEN:
          'errors.server.form.PAPER_VOUCHER_LOST_OR_STOLEN',
        PAPER_VOUCHER_MISSING: 'errors.server.form.PAPER_VOUCHER_MISSING',
        PAPER_VOUCHER_REFUNDED: 'errors.server.form.PAPER_VOUCHER_REFUNDED',
        PERIOD_TOO_SHORT: 'errors.server.form.PERIOD_TOO_SHORT',
        PICKUP_ALREADY_PLANNED: 'errors.server.form.PICKUP_ALREADY_PLANNED',
        START_DATE_CANNOT_BE_BEFORE_2016:
          'errors.server.form.START_DATE_CANNOT_BE_BEFORE_2016',
        START_DATE_GREATER_THAN_END_DATE:
          'errors.server.form.START_DATE_GREATER_THAN_END_DATE',
        TECHNICAL_ERROR: 'errors.server.form.TECHNICAL_ERROR',
        TIME_PERIOD_TOO_LONG: 'errors.server.form.TIME_PERIOD_TOO_LONG',
        UNKNOWN_VALUE: 'errors.server.form.UNKNOWN_VALUE',
        UNREGISTERED_WORKER: 'errors.server.form.UNREGISTERED_WORKER',
        VALUE_ALREADY_EXISTS: 'errors.server.form.VALUE_ALREADY_EXISTS',
        VALUE_TOO_LONG: 'errors.server.form.VALUE_TOO_LONG',
        VALUE_TOO_SHORT: 'errors.server.form.VALUE_TOO_SHORT',
        WORKER_CONTRACT_MISSING: 'errors.server.form.WORKER_CONTRACT_MISSING',
      },
      maintenance: {
        introText: 'errors.server.maintenance.introText',
        title: 'errors.server.maintenance.title',
      },
    },
    serviceUnavailableScreen: {
      cta: 'errors.serviceUnavailableScreen.cta',
      subTitle: 'errors.serviceUnavailableScreen.subTitle',
      title: 'errors.serviceUnavailableScreen.title',
    },
  },
  flanders: {
    footer: {
      overRegionWebsite: 'flanders.footer.overRegionWebsite',
      title: 'flanders.footer.title',
    },
    header: {
      regionName: 'flanders.header.regionName',
    },
  },
  footer: {
    accessibility: 'footer.accessibility',
    appnameTitle: 'footer.appnameTitle',
    cookieManagement: 'footer.cookieManagement',
    copyright: 'footer.copyright',
    cta: {
      complaint: {
        label: 'footer.cta.complaint.label',
      },
      question: {
        label: 'footer.cta.question.label',
      },
    },
    disclaimer: 'footer.disclaimer',
    foremLogoAlt: 'footer.foremLogoAlt',
    nav: {
      cookies: {
        label: 'footer.nav.cookies.label',
      },
      news: {
        label: 'footer.nav.news.label',
        url: 'footer.nav.news.url',
      },
      pp: {
        label: 'footer.nav.pp.label',
      },
      tc: {
        label: 'footer.nav.tc.label',
        url: 'footer.nav.tc.url',
      },
    },
    publishedBy: 'footer.publishedBy',
    subtitle: 'footer.subtitle',
    title: 'footer.title',
  },
  forbiddenWrongRegion: {
    introduction: 'forbiddenWrongRegion.introduction',
    title: 'forbiddenWrongRegion.title',
  },
  general: {
    activeTabLabel: 'general.activeTabLabel',
    activityType: {
      DISABLED_PERSON_TRANSPORTATION:
        'general.activityType.DISABLED_PERSON_TRANSPORTATION',
      GROCERY_SHOPPING: 'general.activityType.GROCERY_SHOPPING',
      HOUSEKEEPING: 'general.activityType.HOUSEKEEPING',
      IRONING: 'general.activityType.IRONING',
    },
    addressType: {
      MAIN: 'general.addressType.MAIN',
      OTHERS: 'general.addressType.OTHERS',
      UNKNOWN: 'general.addressType.UNKNOWN',
    },
    appTitle: 'general.appTitle',
    autoCompletedataLoading: 'general.autoCompletedataLoading',
    breadcrumbLabel: 'general.breadcrumbLabel',
    close: 'general.close',
    cta: {
      cancel: 'general.cta.cancel',
      delete: 'general.cta.delete',
      detail: 'general.cta.detail',
      edit: 'general.cta.edit',
      refresh: 'general.cta.refresh',
      save: 'general.cta.save',
      use: 'general.cta.use',
      useAnotherAccount: 'general.cta.useAnotherAccount',
      validate: 'general.cta.validate',
    },
    datePicker: {
      addonText: 'general.datePicker.addonText',
      addonTooltip: 'general.datePicker.addonTooltip',
    },
    days: {
      FRIDAY: 'general.days.FRIDAY',
      MONDAY: 'general.days.MONDAY',
      SATURDAY: 'general.days.SATURDAY',
      SUNDAY: 'general.days.SUNDAY',
      THURSDAY: 'general.days.THURSDAY',
      TUESDAY: 'general.days.TUESDAY',
      WEDNESDAY: 'general.days.WEDNESDAY',
    },
    daysCount: 'general.daysCount',
    errors: {
      form: {
        autocomplete: {
          minLength: 'general.errors.form.autocomplete.minLength',
        },
        invalidStreet: 'general.errors.form.invalidStreet',
      },
    },
    exploitationName: 'general.exploitationName',
    first: 'general.first',
    form: {
      errorMessage: 'general.form.errorMessage',
      validationErrorMessage: 'general.form.validationErrorMessage',
    },
    frequency: {
      FIRST: 'general.frequency.FIRST',
      FOURTH: 'general.frequency.FOURTH',
      LAST: 'general.frequency.LAST',
      SECOND: 'general.frequency.SECOND',
      THIRD: 'general.frequency.THIRD',
    },
    hidePassword: 'general.hidePassword',
    incorrectType: {
      ACTIVITY_EMPTY: 'general.incorrectType.ACTIVITY_EMPTY',
      AGREEMENT_NUMBER_EMPTY: 'general.incorrectType.AGREEMENT_NUMBER_EMPTY',
      AGREEMENT_NUMBER_INCOMPLETE:
        'general.incorrectType.AGREEMENT_NUMBER_INCOMPLETE',
      CONTRACT_WORKER_NOT_REGISTERED:
        'general.incorrectType.CONTRACT_WORKER_NOT_REGISTERED',
      DATE_OF_WORK_EMPTY: 'general.incorrectType.DATE_OF_WORK_EMPTY',
      DATE_OF_WORK_EXCEEDS: 'general.incorrectType.DATE_OF_WORK_EXCEEDS',
      DATE_OF_WORK_INCOMPLETE: 'general.incorrectType.DATE_OF_WORK_INCOMPLETE',
      NISS_WORKER_EMPTY: 'general.incorrectType.NISS_WORKER_EMPTY',
      NISS_WORKER_INCOMPLETE: 'general.incorrectType.NISS_WORKER_INCOMPLETE',
      NISS_WORKER_NOT_REGISTERED:
        'general.incorrectType.NISS_WORKER_NOT_REGISTERED',
    },
    keyword: 'general.keyword',
    label: {
      activity: 'general.label.activity',
      activityType: 'general.label.activityType',
      author: 'general.label.author',
      authorizationNumber: 'general.label.authorizationNumber',
      bankAccount: 'general.label.bankAccount',
      bceNumber: 'general.label.bceNumber',
      birthdate: 'general.label.birthdate',
      city: 'general.label.city',
      commercialName: 'general.label.commercialName',
      company: 'general.label.company',
      contracts: 'general.label.contracts',
      creationDate: 'general.label.creationDate',
      customer: 'general.label.customer',
      customerName: 'general.label.customerName',
      customerNumber: 'general.label.customerNumber',
      date: 'general.label.date',
      emailAddress: 'general.label.emailAddress',
      enterpriseComment: 'general.label.enterpriseComment',
      fieldDescriptionComment: 'general.label.fieldDescriptionComment',
      error: 'general.label.error',
      export: 'general.label.export',
      exportXLS: 'general.label.exportXLS',
      firstname: 'general.label.firstname',
      lastname: 'general.label.lastname',
      foreignWorker: 'general.label.foreignWorker',
      format: 'general.label.format',
      frequency: 'general.label.frequency',
      function: 'general.label.function',
      gender: 'general.label.gender',
      general: 'general.label.general',
      hourCode: 'general.label.hourCode',
      hqAccount: 'general.label.hqAccount',
      id: 'general.label.id',
      internalReference: 'general.label.internalReference',
      language: 'general.label.language',
      lastModification: 'general.label.lastModification',
      missing: 'general.label.missing',
      mobilePhone: 'general.label.mobilePhone',
      mobilePhoneNumber: 'general.label.mobilePhoneNumber',
      mySubsidiaries: 'general.label.mySubsidiaries',
      name: 'general.label.name',
      niss: 'general.label.niss',
      nissWorker: 'general.label.nissWorker',
      number: 'general.label.number',
      numberOfHours: 'general.label.numberOfHours',
      numberOfServices: 'general.label.numberOfServices',
      onlyFullyAssignedServices: 'general.label.onlyFullyAssignedServices',
      period: 'general.label.period',
      periodFrom: 'general.label.periodFrom',
      periodTo: 'general.label.periodTo',
      phone: 'general.label.phone',
      postcode: 'general.label.postcode',
      present: 'general.label.present',
      quickfilters: 'general.label.quickfilters',
      record: 'general.label.record',
      reset: 'general.label.reset',
      select: {
        all: 'general.label.select.all',
      },
      selected: 'general.label.selected',
      serviceDate: 'general.label.serviceDate',
      sortCreationDates: {
        ASC: 'general.label.sortCreationDates.ASC',
        DESC: 'general.label.sortCreationDates.DESC',
      },
      sortDates: {
        ASC: 'general.label.sortDates.ASC',
        DESC: 'general.label.sortDates.DESC',
      },
      sortNames: {
        ASC: 'general.label.sortNames.ASC',
        DESC: 'general.label.sortNames.DESC',
      },
      sortPostCode: {
        ASC: 'general.label.sortPostCode.ASC',
        DESC: 'general.label.sortPostCode.DESC',
      },
      status: 'general.label.status',
      street: 'general.label.street',
      submit: 'general.label.submit',
      success: 'general.label.success',
      time: 'general.label.time',
      totalTime: 'general.label.totalTime',
      validateAll: 'general.label.validateAll',
      voucher: 'general.label.voucher',
      website: 'general.label.website',
      worker: 'general.label.worker',
      workerControlled: 'general.label.workerControlled',
      workerName: 'general.label.workerName',
      workerNissRef: 'general.label.workerNissRef',
      year: 'general.label.year',
    },
    language: {
      DE: 'general.language.DE',
      EN: 'general.language.EN',
      FR: 'general.language.FR',
      NL: 'general.language.NL',
    },
    last: 'general.last',
    modal: {
      export: {
        cta: {
          download: 'general.modal.export.cta.download',
          openNewTab: 'general.modal.export.cta.openNewTab',
        },
        subtitle: 'general.modal.export.subtitle',
      },
    },
    monthCount: 'general.monthCount',
    navigation: 'general.navigation',
    next: 'general.next',
    noResults: 'general.noResults',
    optionPlaceholder: 'general.optionPlaceholder',
    page: 'general.page',
    pageLoading: 'general.pageLoading',
    pager: {
      goToNextPage: 'general.pager.goToNextPage',
      goToPreviousPage: 'general.pager.goToPreviousPage',
      of: 'general.pager.of',
      showMore: 'general.pager.showMore',
    },
    paperVoucherValidityReference: {
      BLACKLISTED: 'general.paperVoucherValidityReference.BLACKLISTED',
      CANCELLED: 'general.paperVoucherValidityReference.CANCELLED',
      ERROR: 'general.paperVoucherValidityReference.ERROR',
      EXPIRED: 'general.paperVoucherValidityReference.EXPIRED',
      INVALID: 'general.paperVoucherValidityReference.INVALID',
      LOST_OR_STOLEN: 'general.paperVoucherValidityReference.LOST_OR_STOLEN',
      NOT_FOUND: 'general.paperVoucherValidityReference.NOT_FOUND',
      POSTAL_LOSS: 'general.paperVoucherValidityReference.POSTAL_LOSS',
      REFUNDED: 'general.paperVoucherValidityReference.REFUNDED',
      UNKNOWN: 'general.paperVoucherValidityReference.UNKNOWN',
      VALID: 'general.paperVoucherValidityReference.VALID',
    },
    placeholder: {
      datePicker: {
        end: 'general.placeholder.datePicker.end',
        start: 'general.placeholder.datePicker.start',
      },
      search: 'general.placeholder.search',
    },
    prev: 'general.prev',
    previous: 'general.previous',
    search: 'general.search',
    serviceStatus: {
      ACTIVE_CONTESTED: 'general.serviceStatus.ACTIVE_CONTESTED',
      ACTIVE_NOT_ENOUGH_VOUCHERS:
        'general.serviceStatus.ACTIVE_NOT_ENOUGH_VOUCHERS',
      ACTIVE_WAITING_PAYMENT: 'general.serviceStatus.ACTIVE_WAITING_PAYMENT',
      ACTIVE_WAITING_VALIDATION:
        'general.serviceStatus.ACTIVE_WAITING_VALIDATION',
      ALL_EXCEPT_FULLY_IN_REMITTANCE:
        'general.serviceStatus.ALL_EXCEPT_FULLY_IN_REMITTANCE',
      ALL_EXCEPT_IN_REMITTANCE:
        'general.serviceStatus.ALL_EXCEPT_IN_REMITTANCE',
      ARCHIVED_CANCELLED: 'general.serviceStatus.ARCHIVED_CANCELLED',
      ARCHIVED_PAID: 'general.serviceStatus.ARCHIVED_PAID',
      CANCELED: 'general.serviceStatus.CANCELED',
      CONFIRMED: 'general.serviceStatus.CONFIRMED',
      CONTESTED: 'general.serviceStatus.CONTESTED',
      CORRECTED: 'general.serviceStatus.CORRECTED',
      CREATED: 'general.serviceStatus.CREATED',
      MISSING_CONTRACT: 'general.serviceStatus.MISSING_CONTRACT',
      MISSING_VOUCHERS: 'general.serviceStatus.MISSING_VOUCHERS',
      MODIFIED: 'general.serviceStatus.MODIFIED',
      PAID: 'general.serviceStatus.PAID',
      PAID_OUTSIDE_SV: 'general.serviceStatus.PAID_OUTSIDE_SV',
      PARTIALLY_ASSIGNED: 'general.serviceStatus.PARTIALLY_ASSIGNED',
      PARTIALLY_ASSIGNED_SOME_REFUNDED_TO_BE_PAID_OUTSIDE_SV:
        'general.serviceStatus.PARTIALLY_ASSIGNED_SOME_REFUNDED_TO_BE_PAID_OUTSIDE_SV',
      PARTIALLY_ASSIGNED_TO_BE_PAID_OUTSIDE_SV:
        'general.serviceStatus.PARTIALLY_ASSIGNED_TO_BE_PAID_OUTSIDE_SV',
      PARTIALLY_REFUNDED: 'general.serviceStatus.PARTIALLY_REFUNDED',
      PARTIALLY_REFUNDED_TO_BE_PAID_OUTSIDE_SV:
        'general.serviceStatus.PARTIALLY_REFUNDED_TO_BE_PAID_OUTSIDE_SV',
      PROPOSITION_TO_CANCEL: 'general.serviceStatus.PROPOSITION_TO_CANCEL',
      READY_FOR_VOUCHER_ASSIGNMENT:
        'general.serviceStatus.READY_FOR_VOUCHER_ASSIGNMENT',
      REFUND_REQUESTED: 'general.serviceStatus.REFUND_REQUESTED',
      SUBSIDY_REQUESTED: 'general.serviceStatus.SUBSIDY_REQUESTED',
      TO_BE_PAID_OUTSIDE_SV: 'general.serviceStatus.TO_BE_PAID_OUTSIDE_SV',
      VALIDATED: 'general.serviceStatus.VALIDATED',
    },
    services: {
      DISABLED_PERSON_TRANSPORTATION:
        'general.services.DISABLED_PERSON_TRANSPORTATION',
      GROCERY_SHOPPING: 'general.services.GROCERY_SHOPPING',
      HOUSEKEEPING: 'general.services.HOUSEKEEPING',
      IRONING: 'general.services.IRONING',
    },
    showPassword: 'general.showPassword',
    supportType: {
      ELECTRONIC: 'general.supportType.ELECTRONIC',
      PAPER: 'general.supportType.PAPER',
    },
    title: {
      MR: 'general.title.MR',
      MRS: 'general.title.MRS',
    },
    upload: {
      error: 'general.upload.error',
      label: 'general.upload.label',
      labelDrag: 'general.upload.labelDrag',
      remove: 'general.upload.remove',
      removeAll: 'general.upload.removeAll',
    },
    customerStatus: {
      ACTIVE: 'general.customerStatus.ACTIVE',
      FROZEN: 'general.customerStatus.FROZEN',
      BLOCKED: 'general.customerStatus.BLOCKED',
      NOT_FOUND: 'general.customerStatus.NOT_FOUND',
    },
    voucherStatus: {
      INCORRECT: 'general.voucherStatus.INCORRECT',
      REFUSED: 'general.voucherStatus.REFUSED',
      VALID: 'general.voucherStatus.VALID',
    },
  },
  header: {
    appNameTitle: 'header.appNameTitle',
    appNameTitleWithRegion: 'header.appNameTitleWithRegion',
    redirectToRegionHomePage: 'header.redirectToRegionHomePage',
    support: {
      contactList: {
        callus: {
          title: 'header.support.contactList.callus.title',
        },
        contactus: {
          description: 'header.support.contactList.contactus.description',
          link: 'header.support.contactList.contactus.link',
          link_copy: 'header.support.contactList.contactus.link_copy',
          title: 'header.support.contactList.contactus.title',
        },
        findProvider: {
          description: 'header.support.contactList.findProvider.description',
          link: 'header.support.contactList.findProvider.link',
          title: 'header.support.contactList.findProvider.title',
        },
        helpCenter: {
          description: 'header.support.contactList.helpCenter.description',
          link: 'header.support.contactList.helpCenter.link',
          title: 'header.support.contactList.helpCenter.title',
        },
        pass: {
          description: 'header.support.contactList.pass.description',
          title: 'header.support.contactList.pass.title',
        },
      },
      subtitle: 'header.support.subtitle',
      title: 'header.support.title',
    },
  },
  headquarterAndAffiliateManagement: {
    affiliateBankAccountInformation:
      'headquarterAndAffiliateManagement.affiliateBankAccountInformation',
    affiliateCommunicationInformation:
      'headquarterAndAffiliateManagement.affiliateCommunicationInformation',
    alert: {
      changes: {
        body: 'headquarterAndAffiliateManagement.alert.changes.body',
        title: 'headquarterAndAffiliateManagement.alert.changes.title',
      },
    },
    bankAccountNumber: 'headquarterAndAffiliateManagement.bankAccountNumber',
    deactivateAffiliate:
      'headquarterAndAffiliateManagement.deactivateAffiliate',
    deactivateRelativeModal: {
      description:
        'headquarterAndAffiliateManagement.deactivateRelativeModal.description',
      explanation:
        'headquarterAndAffiliateManagement.deactivateRelativeModal.explanation',
      submit:
        'headquarterAndAffiliateManagement.deactivateRelativeModal.submit',
      subtitle:
        'headquarterAndAffiliateManagement.deactivateRelativeModal.subtitle',
      title: 'headquarterAndAffiliateManagement.deactivateRelativeModal.title',
    },
    deactivateThisAffiliate:
      'headquarterAndAffiliateManagement.deactivateThisAffiliate',
    detailsInformation: 'headquarterAndAffiliateManagement.detailsInformation',
    detailsTitle: 'headquarterAndAffiliateManagement.detailsTitle',
    form: {
      cta: {
        request: 'headquarterAndAffiliateManagement.form.cta.request',
      },
    },
    formCommunicationTitle:
      'headquarterAndAffiliateManagement.formCommunicationTitle',
    formDetailsTitle: 'headquarterAndAffiliateManagement.formDetailsTitle',
    formMoreDetailsTitle:
      'headquarterAndAffiliateManagement.formMoreDetailsTitle',
    mobilePhoneNumber: 'headquarterAndAffiliateManagement.mobilePhoneNumber',
    name: 'headquarterAndAffiliateManagement.name',
    searchForAffiliate: 'headquarterAndAffiliateManagement.searchForAffiliate',
    updateAffiliateBankAccount:
      'headquarterAndAffiliateManagement.updateAffiliateBankAccount',
    updateBankAccount: 'headquarterAndAffiliateManagement.updateBankAccount',
    updateBankAccountDocumentDescription:
      'headquarterAndAffiliateManagement.updateBankAccountDocumentDescription',
    updateProvider: {
      errorMessage:
        'headquarterAndAffiliateManagement.updateProvider.errorMessage',
      successMessage:
        'headquarterAndAffiliateManagement.updateProvider.successMessage',
    },
    website: 'headquarterAndAffiliateManagement.website',
  },
  help: {
    introduction: 'help.introduction',
  },
  landing: {
    cards: {
      signin: {
        cta: 'landing.cards.signin.cta',
        description: 'landing.cards.signin.description',
      },
    },
    title: 'landing.title',
  },
  login: {
    usefullLinks: {
      title: 'login.usefullLinks.title',
    },
  },
  navigation: {
    activities: 'navigation.activities',
    backToContactPerson: 'navigation.backToContactPerson',
    backToEnterprise: 'navigation.backToEnterprise',
    backToHomepage: 'navigation.backToHomepage',
    backToWorkers: 'navigation.backToWorkers',
    contactPerson: 'navigation.contactPerson',
    contactPersonDetails: 'navigation.contactPersonDetails',
    dashboard: 'navigation.dashboard',
    enterprise: 'navigation.enterprise',
    enterpriseActivities: 'navigation.enterpriseActivities',
    enterpriseDetails: 'navigation.enterpriseDetails',
    enterpriseDetailsContactPerson: 'navigation.enterpriseDetailsContactPerson',
    enterpriseDetailsVisibility: 'navigation.enterpriseDetailsVisibility',
    error404: 'navigation.error404',
    help: 'navigation.help',
    landing: 'navigation.landing',
    login: 'navigation.login',
    logout: 'navigation.logout',
    pickup: 'navigation.pickup',
    pickupBilling: 'navigation.pickupBilling',
    prestations: 'navigation.prestations',
    prestationsHistory: 'navigation.prestationsHistory',
    prestationsUserStatus: 'navigation.prestationsUserStatus',
    remittances: 'navigation.remittances',
    remittancesReimbursement: 'navigation.remittancesReimbursement',
    serviceUnavailable: 'navigation.serviceUnavailable',
    support: 'navigation.support',
    videos: 'navigation.videos',
    visibility: 'navigation.visibility',
    workerDetails: 'navigation.workerDetails',
    workers: 'navigation.workers',
  },
  orders: {
    cell: {
      processingOrder: 'orders.cell.processingOrder',
    },
  },
  pageTitle: {
    general: 'pageTitle.general',
  },
  pickup: {
    address: {
      to: 'pickup.address.to',
    },
    alert: {
      confirm: {
        delete: {
          RECURRENT: 'pickup.alert.confirm.delete.RECURRENT',
          STANDALONE: 'pickup.alert.confirm.delete.STANDALONE',
        },
        new: 'pickup.alert.confirm.new',
        resume: 'pickup.alert.confirm.resume',
      },
    },
    billing: {
      accessDenied: 'pickup.billing.accessDenied',
      bank: {
        cta: 'pickup.billing.bank.cta',
        introduction: 'pickup.billing.bank.introduction',
        title: 'pickup.billing.bank.title',
      },
      billType: {
        CREDIT_NOTE: 'pickup.billing.billType.CREDIT_NOTE',
        INVOICE: 'pickup.billing.billType.INVOICE',
      },
      contact: {
        errorMessage: 'pickup.billing.contact.errorMessage',
        moreDetails: 'pickup.billing.contact.moreDetails',
        saveModifications: 'pickup.billing.contact.saveModifications',
        successLink: 'pickup.billing.contact.successLink',
        successMessage: 'pickup.billing.contact.successMessage',
        title: 'pickup.billing.contact.title',
      },
      detail: {
        subTitle: 'pickup.billing.detail.subTitle',
        table: {
          enterpriseName: 'pickup.billing.detail.table.enterpriseName',
          pickupDate: 'pickup.billing.detail.table.pickupDate',
        },
        title: 'pickup.billing.detail.title',
      },
      downloadTemplate: {
        fileName: 'pickup.billing.downloadTemplate.fileName',
      },
      introduction: 'pickup.billing.introduction',
      modal: {
        export: {
          title: 'pickup.billing.modal.export.title',
        },
      },
      table: {
        emissionDate: 'pickup.billing.table.emissionDate',
        empty: 'pickup.billing.table.empty',
        reference: 'pickup.billing.table.reference',
        type: 'pickup.billing.table.type',
        vatFreeAmount: 'pickup.billing.table.vatFreeAmount',
        vatIncludedAmount: 'pickup.billing.table.vatIncludedAmount',
      },
    },
    card: {
      cta: 'pickup.card.cta',
      description: 'pickup.card.description',
      tips: {
        cta: 'pickup.card.tips.cta',
        description: 'pickup.card.tips.description',
        title: 'pickup.card.tips.title',
      },
      title: 'pickup.card.title',
    },
    cta: {
      pause: 'pickup.cta.pause',
      play: 'pickup.cta.play',
    },
    delivery: {
      RECURRENT: 'pickup.delivery.RECURRENT',
      STANDALONE: 'pickup.delivery.STANDALONE',
    },
    estimatedCost: {
      month: 'pickup.estimatedCost.month',
    },
    introduction: 'pickup.introduction',
    modal: {
      add: {
        form: {
          EACH_WEEK: 'pickup.modal.add.form.EACH_WEEK',
          WEEK_SELECTION: 'pickup.modal.add.form.WEEK_SELECTION',
          comment: 'pickup.modal.add.form.comment',
          commentInfo: 'pickup.modal.add.form.commentInfo',
          commentLast: 'pickup.modal.add.form.commentLast',
          cta: 'pickup.modal.add.form.cta',
          location: 'pickup.modal.add.form.location',
          oneTime: 'pickup.modal.add.form.oneTime',
          oneTimeOrRecurrence: 'pickup.modal.add.form.oneTimeOrRecurrence',
          pickUpCost: 'pickup.modal.add.form.pickUpCost',
          pickUpDate: 'pickup.modal.add.form.pickUpDate',
          pickUpDateInfo: 'pickup.modal.add.form.pickUpDateInfo',
          pickUpTooltip: 'pickup.modal.add.form.pickUpTooltip',
          pickupOn: 'pickup.modal.add.form.pickupOn',
          recurrence: 'pickup.modal.add.form.recurrence',
          summary: {
            title: 'pickup.modal.add.form.summary.title',
          },
          title: 'pickup.modal.add.form.title',
          weeks: {
            FIRST: 'pickup.modal.add.form.weeks.FIRST',
            FOURTH: 'pickup.modal.add.form.weeks.FOURTH',
            LAST: 'pickup.modal.add.form.weeks.LAST',
            SECOND: 'pickup.modal.add.form.weeks.SECOND',
            THIRD: 'pickup.modal.add.form.weeks.THIRD',
            label: 'pickup.modal.add.form.weeks.label',
          },
        },
        title: 'pickup.modal.add.title',
      },
      delete: {
        RECURRENT: {
          cta: 'pickup.modal.delete.RECURRENT.cta',
          title: 'pickup.modal.delete.RECURRENT.title',
        },
        STANDALONE: {
          cta: 'pickup.modal.delete.STANDALONE.cta',
          title: 'pickup.modal.delete.STANDALONE.title',
        },
      },
      resume: {
        cta: 'pickup.modal.resume.cta',
        text: 'pickup.modal.resume.text',
        title: 'pickup.modal.resume.title',
      },
      tips: {
        intro: 'pickup.modal.tips.intro',
        list: {
          item_1: 'pickup.modal.tips.list.item_1',
          item_2: 'pickup.modal.tips.list.item_2',
          item_3: 'pickup.modal.tips.list.item_3',
          item_4: 'pickup.modal.tips.list.item_4',
          item_5: 'pickup.modal.tips.list.item_5',
          item_6: 'pickup.modal.tips.list.item_6',
          item_7: 'pickup.modal.tips.list.item_7',
        },
        outro: 'pickup.modal.tips.outro',
        title: 'pickup.modal.tips.title',
      },
      update: {
        RECURRENT: {
          cta: 'pickup.modal.update.RECURRENT.cta',
          title: 'pickup.modal.update.RECURRENT.title',
        },
        STANDALONE: {
          cta: 'pickup.modal.update.STANDALONE.cta',
        },
        form: {
          cta: 'pickup.modal.update.form.cta',
          title: 'pickup.modal.update.form.title',
        },
      },
    },
    recurent: {
      info: {
        all: 'pickup.recurent.info.all',
        dates: 'pickup.recurent.info.dates',
        each: 'pickup.recurent.info.each',
      },
    },
    results: {
      address: {
        tooltip: 'pickup.results.address.tooltip',
      },
      tooltip: {
        CANCELED: 'pickup.results.tooltip.CANCELED',
        CONFIRMED: 'pickup.results.tooltip.CONFIRMED',
        NON_WORKING_DAY: 'pickup.results.tooltip.NON_WORKING_DAY',
        PLANNED: 'pickup.results.tooltip.PLANNED',
      },
    },
    status: {
      CANCELED: 'pickup.status.CANCELED',
      CONFIRMED: 'pickup.status.CONFIRMED',
      NON_WORKING_DAY: 'pickup.status.NON_WORKING_DAY',
      PLANNED: 'pickup.status.PLANNED',
    },
    subtitle: {
      dates: 'pickup.subtitle.dates',
    },
    title: {
      dates: 'pickup.title.dates',
      enterprise: 'pickup.title.enterprise',
    },
  },
  pickups: {
    results: {
      noResult: 'pickups.results.noResult',
    },
  },
  prestations: {
    cards: {
      add: {
        content: 'prestations.cards.add.content',
        cta: 'prestations.cards.add.cta',
        title: 'prestations.cards.add.title',
      },
      addList: {
        content: 'prestations.cards.addList.content',
        cta: 'prestations.cards.addList.cta',
        title: 'prestations.cards.addList.title',
      },
      exportList: {
        content: 'prestations.cards.exportList.content',
        cta: 'prestations.cards.exportList.cta',
        title: 'prestations.cards.exportList.title',
      },
    },
    history: {
      introduction: 'prestations.history.introduction',
    },
    customerStatus: {
      introduction: 'prestations.customerStatus.introduction',
      form: {
        userNumber: 'prestations.customerStatus.form.userNumber',
        firstName: 'prestations.customerStatus.form.firstName',
        lastName: 'prestations.customerStatus.form.lastName',
      },
      moreInfoHere: 'prestations.customerStatus.moreInfoHere',
      errorMessage: 'prestations.customerStatus.errorMessage',
    },
    introduction: 'prestations.introduction',
    modals: {
      add: {
        alert: {
          customerStatus: {
            blocked: {
              content:
                'prestations.modals.add.alert.customerStatus.blocked.content',
              title:
                'prestations.modals.add.alert.customerStatus.blocked.title',
            },
            frozen: {
              content:
                'prestations.modals.add.alert.customerStatus.frozen.content',
              title: 'prestations.modals.add.alert.customerStatus.frozen.title',
            },
          },
        },
        confirmation: {
          message: 'prestations.modals.add.confirmation.message',
        },
        cta: 'prestations.modals.add.cta',
        title: 'prestations.modals.add.title',
      },
      alerts: {
        inRemittances: 'prestations.modals.alerts.inRemittances',
        text: {
          CANCELED: 'prestations.modals.alerts.text.CANCELED',
          CONFIRMED: {
            automaticValidationRemaningDays:
              'prestations.modals.alerts.text.CONFIRMED.automaticValidationRemaningDays',
            noRemaningDays:
              'prestations.modals.alerts.text.CONFIRMED.noRemaningDays',
          },
          CONTESTED: {
            activity: 'prestations.modals.alerts.text.CONTESTED.activity',
            worktime: 'prestations.modals.alerts.text.CONTESTED.worktime',
          },
          CORRECTED: 'prestations.modals.alerts.text.CORRECTED',
          CREATED: 'prestations.modals.alerts.text.CREATED',
          MISSING_CONTRACT: 'prestations.modals.alerts.text.MISSING_CONTRACT',
          MISSING_VOUCHERS: 'prestations.modals.alerts.text.MISSING_VOUCHERS',
          MODIFIED: 'prestations.modals.alerts.text.MODIFIED',
          PAID: 'prestations.modals.alerts.text.PAID',
          PAID_OUTSIDE_SV: 'prestations.modals.alerts.text.PAID_OUTSIDE_SV',
          TO_BE_PAID_OUTSIDE_SV:
            'prestations.modals.alerts.text.TO_BE_PAID_OUTSIDE_SV',
        },
        title: {
          CANCELED: 'prestations.modals.alerts.title.CANCELED',
          CONFIRMED: 'prestations.modals.alerts.title.CONFIRMED',
          CONTESTED: 'prestations.modals.alerts.title.CONTESTED',
          CORRECTED: 'prestations.modals.alerts.title.CORRECTED',
          CREATED: 'prestations.modals.alerts.title.CREATED',
          MISSING_CONTRACT: 'prestations.modals.alerts.title.MISSING_CONTRACT',
          MISSING_VOUCHERS: 'prestations.modals.alerts.title.MISSING_VOUCHERS',
          MODIFIED: 'prestations.modals.alerts.title.MODIFIED',
          PAID: 'prestations.modals.alerts.title.PAID',
          PAID_OUTSIDE_SV: 'prestations.modals.alerts.title.PAID_OUTSIDE_SV',
          PARTIALLY_ASSIGNED:
            'prestations.modals.alerts.title.PARTIALLY_ASSIGNED',
          PARTIALLY_ASSIGNED_SOME_REFUNDED_TO_BE_PAID_OUTSIDE_SV:
            'prestations.modals.alerts.title.PARTIALLY_ASSIGNED_SOME_REFUNDED_TO_BE_PAID_OUTSIDE_SV',
          PARTIALLY_ASSIGNED_TO_BE_PAID_OUTSIDE_SV:
            'prestations.modals.alerts.title.PARTIALLY_ASSIGNED_TO_BE_PAID_OUTSIDE_SV',
          PARTIALLY_REFUNDED:
            'prestations.modals.alerts.title.PARTIALLY_REFUNDED',
          PARTIALLY_REFUNDED_TO_BE_PAID_OUTSIDE_SV:
            'prestations.modals.alerts.title.PARTIALLY_REFUNDED_TO_BE_PAID_OUTSIDE_SV',
          PROPOSITION_TO_CANCEL:
            'prestations.modals.alerts.title.PROPOSITION_TO_CANCEL',
          READY_FOR_VOUCHER_ASSIGNMENT:
            'prestations.modals.alerts.title.READY_FOR_VOUCHER_ASSIGNMENT',
          REFUND_REQUESTED: 'prestations.modals.alerts.title.REFUND_REQUESTED',
          TO_BE_PAID_OUTSIDE_SV:
            'prestations.modals.alerts.title.TO_BE_PAID_OUTSIDE_SV',
          VALIDATED: 'prestations.modals.alerts.title.VALIDATED',
          currentStatus: 'prestations.modals.alerts.title.currentStatus',
        },
      },
      bringsModifications: 'prestations.modals.bringsModifications',
      cancel: {
        confirmation: {
          message: 'prestations.modals.cancel.confirmation.message',
        },
        cta: 'prestations.modals.cancel.cta',
        title: 'prestations.modals.cancel.title',
      },
      comments: {
        title: 'prestations.modals.comments.title',
      },
      details: {
        title: 'prestations.modals.details.title',
      },
      edit: {
        confirmation: {
          message: 'prestations.modals.edit.confirmation.message',
        },
        cta: 'prestations.modals.edit.cta',
        title: 'prestations.modals.edit.title',
      },
      export: {
        downloadTemplate: {
          fileName: 'prestations.modals.export.downloadTemplate.fileName',
        },
        errorMessage: 'prestations.modals.export.errorMessage',
        form: {
          labels: {
            format: 'prestations.modals.export.form.labels.format',
            status: 'prestations.modals.export.form.labels.status',
            workMonth: 'prestations.modals.export.form.labels.workMonth',
          },
        },
        subtitle: 'prestations.modals.export.subtitle',
        title: 'prestations.modals.export.title',
      },
      import: {
        confirmation: {
          alert: {
            created: 'prestations.modals.import.confirmation.alert.created',
            error: {
              messageBottom:
                'prestations.modals.import.confirmation.alert.error.messageBottom',
              title: 'prestations.modals.import.confirmation.alert.error.title',
            },
            refused: 'prestations.modals.import.confirmation.alert.refused',
            success: {
              title:
                'prestations.modals.import.confirmation.alert.success.title',
            },
          },
          downloadReport: {
            fileName:
              'prestations.modals.import.confirmation.downloadReport.fileName',
            generate:
              'prestations.modals.import.confirmation.downloadReport.generate',
            linkTitle:
              'prestations.modals.import.confirmation.downloadReport.linkTitle',
            title:
              'prestations.modals.import.confirmation.downloadReport.title',
          },
        },
        form: {
          cta: {
            title: 'prestations.modals.import.form.cta.title',
          },
          labels: {
            newUpload: 'prestations.modals.import.form.labels.newUpload',
          },
        },
        help: {
          step1: {
            title: 'prestations.modals.import.help.step1.title',
          },
          step2: {
            title: 'prestations.modals.import.help.step2.title',
          },
          step3: {
            title: 'prestations.modals.import.help.step3.title',
          },
          title: 'prestations.modals.import.help.title',
        },
        lastImport: {
          title: 'prestations.modals.import.lastImport.title',
        },
        processingImport: {
          content: 'prestations.modals.import.processingImport.content',
        },
        title: 'prestations.modals.import.title',
      },
      suggestModifications: 'prestations.modals.suggestModifications',
      WorkerSuggestModifications:
        'prestations.modals.WorkerSuggestModifications',
      validate: {
        alert: {
          validateAllForWorker: {
            error:
              'prestations.modals.validate.alert.validateAllForWorker.error',
            success:
              'prestations.modals.validate.alert.validateAllForWorker.success',
          },
          validateAllForWorkers: {
            error:
              'prestations.modals.validate.alert.validateAllForWorkers.error',
            success:
              'prestations.modals.validate.alert.validateAllForWorkers.success',
          },
          validateForWorker: {
            error: 'prestations.modals.validate.alert.validateForWorker.error',
            success:
              'prestations.modals.validate.alert.validateForWorker.success',
          },
        },
      },
      pluxee: 'prestations.modals.pluxee',
      you: 'prestations.modals.you',
    },
    search: {
      alert: {
        title: 'prestations.search.alert.title',
        toolTip: {
          CANCELED: 'prestations.search.alert.toolTip.CANCELED',
          INREMITTANCE: 'prestations.search.alert.toolTip.INREMITTANCE',
          TOBEPAIDOUTSIDESV:
            'prestations.search.alert.toolTip.TOBEPAIDOUTSIDESV',
        },
      },
      form: {
        labels: {
          customerNameAndNumber:
            'prestations.search.form.labels.customerNameAndNumber',
          prestationDate: 'prestations.search.form.labels.prestationDate',
          prestationDateEnd: 'prestations.search.form.labels.prestationDateEnd',
          prestationDateStart:
            'prestations.search.form.labels.prestationDateStart',
          workerNameOrNiss: 'prestations.search.form.labels.workerNameOrNiss',
        },
      },
      modal: {
        validate: 'prestations.search.modal.validate',
        validateAll: 'prestations.search.modal.validateAll',
        validateAllForWorker: 'prestations.search.modal.validateAllForWorker',
      },
      noResults: 'prestations.search.noResults',
      overview: {
        canceled: 'prestations.search.overview.canceled',
        contested: 'prestations.search.overview.contested',
        inRemittance: 'prestations.search.overview.inRemittance',
        missingContract: 'prestations.search.overview.missingContract',
        missingVouchers: 'prestations.search.overview.missingVouchers',
        toBePaidOutsideSv: 'prestations.search.overview.toBePaidOutsideSv',
        vouchersAssigned: 'prestations.search.overview.vouchersAssigned',
        waitingForConfirmation:
          'prestations.search.overview.waitingForConfirmation',
        waitingForValidation:
          'prestations.search.overview.waitingForValidation',
      },
      table: {
        head: {
          actions: {
            pendingWorks: 'prestations.search.table.head.actions.pendingWorks',
          },
        },
        showMore: 'prestations.search.table.showMore',
        status: {
          text: {
            CANCELED: 'prestations.search.table.status.text.CANCELED',
            CONFIRMED: {
              confirmedByWorker:
                'prestations.search.table.status.text.CONFIRMED.confirmedByWorker',
              confirmedByCustomer:
                'prestations.search.table.status.text.CONFIRMED.confirmedByCustomer',
              automaticValidationRemainingDays:
                'prestations.search.table.status.text.CONFIRMED.automaticValidationRemainingDays',
            },
            CONTESTED: {
              activity:
                'prestations.search.table.status.text.CONTESTED.activity',
              duration:
                'prestations.search.table.status.text.CONTESTED.duration',
              durationAndActivity:
                'prestations.search.table.status.text.CONTESTED.durationAndActivity',
              opposedByWorker:
                'prestations.search.table.status.text.CONTESTED.opposedByWorker',
              opposedByCustomer:
                'prestations.search.table.status.text.CONTESTED.opposedByCustomer',
            },
            CORRECTED: 'prestations.search.table.status.text.CORRECTED',
            CREATED: 'prestations.search.table.status.text.CREATED',
            MISSING_CONTRACT:
              'prestations.search.table.status.text.MISSING_CONTRACT',
            MISSING_VOUCHERS:
              'prestations.search.table.status.text.MISSING_VOUCHERS',
            MODIFIED: 'prestations.search.table.status.text.MODIFIED',
            PAID: 'prestations.search.table.status.text.PAID',
            PARTIALLY: {
              assignedVouchers:
                'prestations.search.table.status.text.PARTIALLY.assignedVouchers',
              cta: 'prestations.search.table.status.text.PARTIALLY.cta',
              remittableVouchers:
                'prestations.search.table.status.text.PARTIALLY.remittableVouchers',
              remittedVouchers:
                'prestations.search.table.status.text.PARTIALLY.remittedVouchers',
            },
            PARTIALLY_ASSIGNED: {
              tooltip:
                'prestations.search.table.status.text.PARTIALLY_ASSIGNED.tooltip',
            },
            PARTIALLY_REFUNDED: {
              tooltip:
                'prestations.search.table.status.text.PARTIALLY_REFUNDED.tooltip',
            },
            PROPOSITION_TO_CANCEL:
              'prestations.search.table.status.text.PROPOSITION_TO_CANCEL',
            READY_FOR_VOUCHER_ASSIGNMENT:
              'prestations.search.table.status.text.READY_FOR_VOUCHER_ASSIGNMENT',
            SUBSIDY_REQUESTED:
              'prestations.search.table.status.text.SUBSIDY_REQUESTED',
            TO_BE_PAID_OUTSIDE_SV:
              'prestations.search.table.status.text.TO_BE_PAID_OUTSIDE_SV',
            TO_BE_PARTIALLY_PAID_OUTSIDE_SV:
              'prestations.search.table.status.text.TO_BE_PARTIALLY_PAID_OUTSIDE_SV',
            VALIDATED: {
              automaticCustomerValidationRemainingDays:
                'prestations.search.table.status.text.VALIDATED.automaticCustomerValidationRemainingDays',
              automaticWorkerValidationRemainingDays:
                'prestations.search.table.status.text.VALIDATED.automaticWorkerValidationRemainingDays',
            },
          },
        },
      },
      tabs: {
        list: 'prestations.search.tabs.list',
        worker: 'prestations.search.tabs.worker',
      },
      title: 'prestations.search.title',
      totalPendingWorks: 'prestations.search.totalPendingWorks',
    },
  },
  profile: {
    changeEmailModal: {
      oldEmailAddress: 'profile.changeEmailModal.oldEmailAddress',
      title: 'profile.changeEmailModal.title',
    },
    changePasswordModal: {
      description: 'profile.changePasswordModal.description',
      passwordRules: 'profile.changePasswordModal.passwordRules',
      title: 'profile.changePasswordModal.title',
    },
    confirmNewPassword: 'profile.confirmNewPassword',
    cta: {
      changePassword: 'profile.cta.changePassword',
    },
    currentPassword: 'profile.currentPassword',
    emailAddressConfirmation: 'profile.emailAddressConfirmation',
    error: {
      notPasted: 'profile.error.notPasted',
    },
    forgotPassword: 'profile.forgotPassword',
    introduction: 'profile.introduction',
    loggedAs: {
      title: 'profile.loggedAs.title',
    },
    loginSection: {
      title: 'profile.loginSection.title',
    },
    newPassword: 'profile.newPassword',
    requestMandate: 'profile.requestMandate',
    title: 'profile.title',
    updateEmailAddressSubtitle: 'profile.updateEmailAddressSubtitle',
    updateEmailAddressTitle: 'profile.updateEmailAddressTitle',
    updatePassword: {
      introduction: 'profile.updatePassword.introduction',
      title: 'profile.updatePassword.title',
    },
    updateProfile: {
      errorMessage: 'profile.updateProfile.errorMessage',
      successMessage: 'profile.updateProfile.successMessage',
    },
  },
  profileSettings: {
    dashboard: 'profileSettings.dashboard',
    importantInformation: 'profileSettings.importantInformation',
    myCalendar: 'profileSettings.myCalendar',
    myEnterprise: 'profileSettings.myEnterprise',
    myWorkers: 'profileSettings.myWorkers',
    updateContactInformation: 'profileSettings.updateContactInformation',
  },
  register: {
    errors: {
      form: {
        minFifteenYearOld: 'register.errors.form.minFifteenYearOld',
        minSixteenYearOld: 'register.errors.form.minSixteenYearOld',
      },
    },
  },
  relative: {
    add: {
      activity: {
        title: 'relative.add.activity.title',
      },
      bankAccount: {
        headquarterAccount: 'relative.add.bankAccount.headquarterAccount',
        title: 'relative.add.bankAccount.title',
      },
      contactPerson: {
        title: 'relative.add.contactPerson.title',
      },
      introduction: 'relative.add.introduction',
      label: {
        affiliateCommercialName: 'relative.add.label.affiliateCommercialName',
        language: 'relative.add.label.language',
        legalForm: 'relative.add.label.legalForm',
        reimbursementChoice: 'relative.add.label.reimbursementChoice',
      },
      mainTitle: 'relative.add.mainTitle',
      reimbursementType: {
        grouped: {
          label: 'relative.add.reimbursementType.grouped.label',
          tooltip: {
            message: 'relative.add.reimbursementType.grouped.tooltip.message',
          },
        },
        individual: {
          label: 'relative.add.reimbursementType.individual.label',
          tooltip: {
            message:
              'relative.add.reimbursementType.individual.tooltip.message',
          },
        },
      },
      step: {
        communication: 'relative.add.step.communication',
        details: 'relative.add.step.details',
        specifications: 'relative.add.step.specifications',
      },
    },
  },
  relativeType: {
    headquarter: 'relativeType.headquarter',
    subsidiary: 'relativeType.subsidiary',
  },
  relatives: {
    affiliate: {
      sortPostalCodeAsc: 'relatives.affiliate.sortPostalCodeAsc',
      sortPostalCodeDesc: 'relatives.affiliate.sortPostalCodeDesc',
    },
    editHeadquarter: {
      ariaLabel: 'relatives.editHeadquarter.ariaLabel',
    },
    myAffiliates: {
      addNewAffiliate: 'relatives.myAffiliates.addNewAffiliate',
      alert: {
        successMessage: 'relatives.myAffiliates.alert.successMessage',
      },
      title: 'relatives.myAffiliates.title',
    },
    myHeadquarter: {
      title: 'relatives.myHeadquarter.title',
    },
    searchForAffiliate: 'relatives.searchForAffiliate',
    title: 'relatives.title',
  },
  remittances: {
    cards: {
      automatic: {
        cta: 'remittances.cards.automatic.cta',
        description: 'remittances.cards.automatic.description',
        title: 'remittances.cards.automatic.title',
      },
      deliverySlips: {
        cta: {
          createDeliverySlip:
            'remittances.cards.deliverySlips.cta.createDeliverySlip',
          downloadTemplate:
            'remittances.cards.deliverySlips.cta.downloadTemplate',
        },
        description: 'remittances.cards.deliverySlips.description',
        title: 'remittances.cards.deliverySlips.title',
      },
      manual: {
        cta: 'remittances.cards.manual.cta',
        description: 'remittances.cards.manual.description',
        title: 'remittances.cards.manual.title',
      },
      pickupPlanning: {
        cta: {
          managePlanning: 'remittances.cards.pickupPlanning.cta.managePlanning',
        },
        description: 'remittances.cards.pickupPlanning.description',
        title: 'remittances.cards.pickupPlanning.title',
      },
      vouchersDeclaration: {
        cta: {
          declareVoucher:
            'remittances.cards.vouchersDeclaration.cta.declareVoucher',
          importList: 'remittances.cards.vouchersDeclaration.cta.importList',
        },
        description: 'remittances.cards.vouchersDeclaration.description',
        title: 'remittances.cards.vouchersDeclaration.title',
      },
      vouchersValidity: {
        cta: 'remittances.cards.vouchersValidity.cta',
        description: 'remittances.cards.vouchersValidity.description',
        title: 'remittances.cards.vouchersValidity.title',
      },
    },
    correctModal: {
      title: 'remittances.correctModal.title',
    },
    correction: {
      set: 'remittances.correction.set',
    },
    detailModal: {
      generalView: {
        title: 'remittances.detailModal.generalView.title',
      },
      monthlyView: {
        monthOfIssue: 'remittances.detailModal.monthlyView.monthOfIssue',
        monthOfWork: 'remittances.detailModal.monthlyView.monthOfWork',
        reimbursementValue:
          'remittances.detailModal.monthlyView.reimbursementValue',
        subsidyCalculationBasis:
          'remittances.detailModal.monthlyView.subsidyCalculationBasis',
        title: 'remittances.detailModal.monthlyView.title',
      },
      title: 'remittances.detailModal.title',
    },
    downloadTemplate: {
      fileName: 'remittances.downloadTemplate.fileName',
      title: 'remittances.downloadTemplate.title',
      titleOpen: 'remittances.downloadTemplate.titleOpen',
    },
    general: {
      agreementNumber: {
        BE_BRU: 'remittances.general.agreementNumber.BE_BRU',
        BE_VLG: 'remittances.general.agreementNumber.BE_VLG',
        BE_WAL: 'remittances.general.agreementNumber.BE_WAL',
      },
      announced: 'remittances.general.announced',
      arrivalDate: 'remittances.general.arrivalDate',
      correctionDeadline: 'remittances.general.correctionDeadline',
      exploitationName: 'remittances.general.exploitationName',
      firstReimbursement: 'remittances.general.firstReimbursement',
      freeReference: 'remittances.general.freeReference',
      missing: 'remittances.general.missing',
      month: 'remittances.general.month',
      monthPrestation: 'remittances.general.monthPrestation',
      no: 'remittances.general.no',
      number: 'remittances.general.number',
      numberVouchers: 'remittances.general.numberVouchers',
      present: 'remittances.general.present',
      prestationDate: 'remittances.general.prestationDate',
      processing: 'remittances.general.processing',
      read: 'remittances.general.read',
      reference: 'remittances.general.reference',
      refused: 'remittances.general.refused',
      registeredWorker: 'remittances.general.registeredWorker',
      reimbursed: 'remittances.general.reimbursed',
      reimbursedAmount: 'remittances.general.reimbursedAmount',
      reimbursementCenter: 'remittances.general.reimbursementCenter',
      remittanceNumber: 'remittances.general.remittanceNumber',
      submit: 'remittances.general.submit',
      toCorrect: 'remittances.general.toCorrect',
      totalReimbursement: 'remittances.general.totalReimbursement',
      type: 'remittances.general.type',
      voucherStatus: 'remittances.general.voucherStatus',
      vouchers: 'remittances.general.vouchers',
      workerContract: 'remittances.general.workerContract',
      yes: 'remittances.general.yes',
    },
    modal: {
      automatic: {
        applyFrequency: 'remittances.modal.automatic.applyFrequency',
        onlyFullyAssignedServices: {
          definition:
            'remittances.modal.automatic.onlyFullyAssignedServices.definition',
        },
        title: 'remittances.modal.automatic.title',
      },
      checkVoucherValidity: {
        cta: {
          checkValidity:
            'remittances.modal.checkVoucherValidity.cta.checkValidity',
        },
        description: {
          noScanner: {
            content:
              'remittances.modal.checkVoucherValidity.description.noScanner.content',
            title:
              'remittances.modal.checkVoucherValidity.description.noScanner.title',
          },
          scanner: {
            content:
              'remittances.modal.checkVoucherValidity.description.scanner.content',
            title:
              'remittances.modal.checkVoucherValidity.description.scanner.title',
          },
          title: 'remittances.modal.checkVoucherValidity.description.title',
        },
        errorMessage: 'remittances.modal.checkVoucherValidity.errorMessage',
        serialInput: {
          label: 'remittances.modal.checkVoucherValidity.serialInput.label',
        },
        successMessage: 'remittances.modal.checkVoucherValidity.successMessage',
        title: 'remittances.modal.checkVoucherValidity.title',
      },
      createDeliverySlip: {
        cta: {
          submit: 'remittances.modal.createDeliverySlip.cta.submit',
        },
        errorMessage: 'remittances.modal.createDeliverySlip.errorMessage',
        form: {
          labels: {
            exploitationName:
              'remittances.modal.createDeliverySlip.form.labels.exploitationName',
            freeReference:
              'remittances.modal.createDeliverySlip.form.labels.freeReference',
            vouchersAmount:
              'remittances.modal.createDeliverySlip.form.labels.vouchersAmount',
            workMonth:
              'remittances.modal.createDeliverySlip.form.labels.workMonth',
          },
        },
        subtitle: 'remittances.modal.createDeliverySlip.subtitle',
        successMessage: 'remittances.modal.createDeliverySlip.successMessage',
        title: 'remittances.modal.createDeliverySlip.title',
      },
      declareVoucher: {
        cta: {
          submit: 'remittances.modal.declareVoucher.cta.submit',
        },
        form: {
          labels: {
            activity: 'remittances.modal.declareVoucher.form.labels.activity',
            exploitationName:
              'remittances.modal.declareVoucher.form.labels.exploitationName',
            nissWorker:
              'remittances.modal.declareVoucher.form.labels.nissWorker',
            prestationDate:
              'remittances.modal.declareVoucher.form.labels.prestationDate',
            voucherSerialNumber:
              'remittances.modal.declareVoucher.form.labels.voucherSerialNumber',
            vouchersList:
              'remittances.modal.declareVoucher.form.labels.vouchersList',
          },
          statusMessage: {
            error: 'remittances.modal.declareVoucher.form.statusMessage.error',
            success:
              'remittances.modal.declareVoucher.form.statusMessage.success',
          },
        },
        processing: {
          message: 'remittances.modal.declareVoucher.processing.message',
        },
        success: {
          message: 'remittances.modal.declareVoucher.success.message',
          title: 'remittances.modal.declareVoucher.success.title',
        },
        title: 'remittances.modal.declareVoucher.title',
        totalVouchers: 'remittances.modal.declareVoucher.totalVouchers',
      },
      declareVouchers: {
        cta: {
          title: 'remittances.modal.declareVouchers.cta.title',
        },
        step1: {
          title: 'remittances.modal.declareVouchers.step1.title',
        },
        step2: {
          list: {
            item1: 'remittances.modal.declareVouchers.step2.list.item1',
            item2: 'remittances.modal.declareVouchers.step2.list.item2',
            item3: 'remittances.modal.declareVouchers.step2.list.item3',
            item4: 'remittances.modal.declareVouchers.step2.list.item4',
          },
          title: 'remittances.modal.declareVouchers.step2.title',
        },
        step3: {
          title: 'remittances.modal.declareVouchers.step3.title',
        },
        stepTitle: 'remittances.modal.declareVouchers.stepTitle',
        stepUpload: 'remittances.modal.declareVouchers.stepUpload',
        title: 'remittances.modal.declareVouchers.title',
      },
      deliverySlipTemplate: {
        description: 'remittances.modal.deliverySlipTemplate.description',
        openPdfTemplate: {
          title: 'remittances.modal.deliverySlipTemplate.openPdfTemplate.title',
        },
        pdftemplate: {
          metaData:
            'remittances.modal.deliverySlipTemplate.pdftemplate.metaData',
          mimeType:
            'remittances.modal.deliverySlipTemplate.pdftemplate.mimeType',
          title: 'remittances.modal.deliverySlipTemplate.pdftemplate.title',
        },
        subTitle: 'remittances.modal.deliverySlipTemplate.subTitle',
        title: 'remittances.modal.deliverySlipTemplate.title',
      },
      export: {
        downloadTemplate: {
          fileName: 'remittances.modal.export.downloadTemplate.fileName',
        },
        title: 'remittances.modal.export.title',
      },
      exportRemittanceWorks: {
        text: 'remittances.modal.exportRemittanceWorks.text',
        title: 'remittances.modal.exportRemittanceWorks.title',
      },
      incorrect: {
        alert: {
          cta: 'remittances.modal.incorrect.alert.cta',
          title: 'remittances.modal.incorrect.alert.title',
          titleSuccess: 'remittances.modal.incorrect.alert.titleSuccess',
        },
        form: {
          label: {
            errorType: 'remittances.modal.incorrect.form.label.errorType',
          },
        },
        tip: 'remittances.modal.incorrect.tip',
      },
      manual: {
        confirmation: {
          alertMessage: 'remittances.modal.manual.confirmation.alertMessage',
        },
        form: {
          day: {
            friday: 'remittances.modal.manual.form.day.friday',
            monday: 'remittances.modal.manual.form.day.monday',
            saturday: 'remittances.modal.manual.form.day.saturday',
            sunday: 'remittances.modal.manual.form.day.sunday',
            thursday: 'remittances.modal.manual.form.day.thursday',
            tuesday: 'remittances.modal.manual.form.day.tuesday',
            wednesday: 'remittances.modal.manual.form.day.wednesday',
          },
          frequencyOption: {
            daily: 'remittances.modal.manual.form.frequencyOption.daily',
            monthly: 'remittances.modal.manual.form.frequencyOption.monthly',
            none: 'remittances.modal.manual.form.frequencyOption.none',
            weekly: 'remittances.modal.manual.form.frequencyOption.weekly',
          },
          month: {
            APRIL: 'remittances.modal.manual.form.month.APRIL',
            AUGUST: 'remittances.modal.manual.form.month.AUGUST',
            DECEMBER: 'remittances.modal.manual.form.month.DECEMBER',
            FEBRUARY: 'remittances.modal.manual.form.month.FEBRUARY',
            JANUARY: 'remittances.modal.manual.form.month.JANUARY',
            JULY: 'remittances.modal.manual.form.month.JULY',
            JUNE: 'remittances.modal.manual.form.month.JUNE',
            MARCH: 'remittances.modal.manual.form.month.MARCH',
            MAY: 'remittances.modal.manual.form.month.MAY',
            NOVEMBER: 'remittances.modal.manual.form.month.NOVEMBER',
            OCTOBER: 'remittances.modal.manual.form.month.OCTOBER',
            SEPTEMBER: 'remittances.modal.manual.form.month.SEPTEMBER',
          },
          repeatWeeklyLabel: 'remittances.modal.manual.form.repeatWeeklyLabel',
          update: {
            successMessage:
              'remittances.modal.manual.form.update.successMessage',
          },
        },
        onlyFullyAssignedServices: {
          text: 'remittances.modal.manual.onlyFullyAssignedServices.text',
        },
        reference: {
          cta: 'remittances.modal.manual.reference.cta',
          title: 'remittances.modal.manual.reference.title',
        },
        results: {
          selectAll: 'remittances.modal.manual.results.selectAll',
          title: 'remittances.modal.manual.results.title',
          tooltip: 'remittances.modal.manual.results.tooltip',
          tooltip2: 'remittances.modal.manual.results.tooltip2',
        },
        summary: {
          title: 'remittances.modal.manual.summary.title',
        },
        title: 'remittances.modal.manual.title',
      },
      status: {
        inRemittancesDescription: 'remittances.modal.inRemittances.description',
      },
    },
    refusalReasons: {
      ACTIVITY_APPROVAL: 'remittances.refusalReasons.ACTIVITY_APPROVAL',
      ACTIVITY_COMPLETE: 'remittances.refusalReasons.ACTIVITY_COMPLETE',
      CANCELLED_BY_CUSTOMER: 'remittances.refusalReasons.CANCELLED_BY_CUSTOMER',
      CANCELLED_BY_PROVIDER: 'remittances.refusalReasons.CANCELLED_BY_PROVIDER',
      CIREF_COMPLETE: 'remittances.refusalReasons.CIREF_COMPLETE',
      COMPANY_APPROVAL: 'remittances.refusalReasons.COMPANY_APPROVAL',
      CUSTSIGN_COMPLETE: 'remittances.refusalReasons.CUSTSIGN_COMPLETE',
      INCOMPLETE: 'remittances.refusalReasons.INCOMPLETE',
      NISS_MISSING: 'remittances.refusalReasons.NISS_MISSING',
      OUTDATED: 'remittances.refusalReasons.OUTDATED',
      REGISTERED_WORKER: 'remittances.refusalReasons.REGISTERED_WORKER',
      REMITTANCE_DATE_VOUCHER_ISSUE_DELAY:
        'remittances.refusalReasons.REMITTANCE_DATE_VOUCHER_ISSUE_DELAY',
      UNRECOGNIZED: 'remittances.refusalReasons.UNRECOGNIZED',
      WORKDATE_COMPLETE: 'remittances.refusalReasons.WORKDATE_COMPLETE',
      WORKDATE_MISSING: 'remittances.refusalReasons.WORKDATE_MISSING',
      WORKERSIGN_COMPLETE: 'remittances.refusalReasons.WORKERSIGN_COMPLETE',
      WORKER_CONTRACT: 'remittances.refusalReasons.WORKER_CONTRACT',
      WORKER_HOURS_LIMIT: 'remittances.refusalReasons.WORKER_HOURS_LIMIT',
      WORK_VCHISSUE_DELAY: 'remittances.refusalReasons.WORK_VCHISSUE_DELAY',
      label: 'remittances.refusalReasons.label',
    },
    refusedModal: {
      downloadTemplate: {
        fileName: 'remittances.refusedModal.downloadTemplate.fileName',
      },
      table: {
        tableHead: {
          emission: 'remittances.refusedModal.table.tableHead.emission',
          user: 'remittances.refusedModal.table.tableHead.user',
          userId: 'remittances.refusedModal.table.tableHead.userId',
        },
      },
      title: 'remittances.refusedModal.title',
    },
    reimbursement: {
      introduction: 'remittances.reimbursement.introduction',
      modal: {
        card: {
          cta: 'remittances.reimbursement.modal.card.cta',
        },
        cta: {
          modifyBankAccount:
            'remittances.reimbursement.modal.cta.modifyBankAccount',
          submit: 'remittances.reimbursement.modal.cta.submit',
        },
        description: 'remittances.reimbursement.modal.description',
        detail: {
          amountReceived:
            'remittances.reimbursement.modal.detail.amountReceived',
          general: {
            title: 'remittances.reimbursement.modal.detail.general.title',
          },
          issuePeriod: 'remittances.reimbursement.modal.detail.issuePeriod',
          monthly: {
            title: 'remittances.reimbursement.modal.detail.monthly.title',
          },
          subsidyCalculationBasis:
            'remittances.reimbursement.modal.detail.subsidyCalculationBasis',
          title: 'remittances.reimbursement.modal.detail.title',
          total: 'remittances.reimbursement.modal.detail.total',
          unitValue: 'remittances.reimbursement.modal.detail.unitValue',
          voucherQuantity:
            'remittances.reimbursement.modal.detail.voucherQuantity',
          workMonth: 'remittances.reimbursement.modal.detail.workMonth',
        },
        errors: {
          noSubsidies: 'remittances.reimbursement.modal.errors.noSubsidies',
        },
        exploitationName: {
          title: 'remittances.reimbursement.modal.exploitationName.title',
        },
        export: {
          downloadTemplate: {
            fileName:
              'remittances.reimbursement.modal.export.downloadTemplate.fileName',
          },
          title: 'remittances.reimbursement.modal.export.title',
        },
        title: 'remittances.reimbursement.modal.title',
        type: {
          grouped: 'remittances.reimbursement.modal.type.grouped',
          individual: 'remittances.reimbursement.modal.type.individual',
          title: 'remittances.reimbursement.modal.type.title',
        },
      },
      search: {
        form: {
          isBlocked: 'remittances.reimbursement.search.form.isBlocked',
          period: 'remittances.reimbursement.search.form.period',
          relativeId: 'remittances.reimbursement.search.form.relativeId',
          serviceMonthPeriod:
            'remittances.reimbursement.search.form.serviceMonthPeriod',
          supportType: 'remittances.reimbursement.search.form.supportType',
        },
        table: {
          dateOfPayment: 'remittances.reimbursement.search.table.dateOfPayment',
          monthOfWork: 'remittances.reimbursement.search.table.monthOfWork',
          noResults: 'remittances.reimbursement.search.table.noResults',
          paymentAmount: 'remittances.reimbursement.search.table.paymentAmount',
          paymentReference:
            'remittances.reimbursement.search.table.paymentReference',
          refundCenter: 'remittances.reimbursement.search.table.refundCenter',
          refundedVoucherQuantity:
            'remittances.reimbursement.search.table.refundedVoucherQuantity',
          remittanceReference:
            'remittances.reimbursement.search.table.remittanceReference',
          remittancesId: 'remittances.reimbursement.search.table.remittancesId',
          seizureBlocking:
            'remittances.reimbursement.search.table.seizureBlocking',
          supportType: 'remittances.reimbursement.search.table.supportType',
        },
        title: 'remittances.reimbursement.search.title',
      },
      sort: {
        MONTH_OF_WORK_ASC: 'remittances.reimbursement.sort.MONTH_OF_WORK_ASC',
        MONTH_OF_WORK_DESC: 'remittances.reimbursement.sort.MONTH_OF_WORK_DESC',
        REFUND_CENTER_ASC: 'remittances.reimbursement.sort.REFUND_CENTER_ASC',
        REFUND_CENTER_DESC: 'remittances.reimbursement.sort.REFUND_CENTER_DESC',
      },
    },
    search: {
      cta: {
        export: 'remittances.search.cta.export',
      },
      form: {
        cta: 'remittances.search.form.cta',
        period: 'remittances.search.form.period',
        voucherStatus: 'remittances.search.form.voucherStatus',
      },
      subtitle: 'remittances.search.subtitle',
      table: {
        vouchers: {
          announced: 'remittances.search.table.vouchers.announced',
          refused: 'remittances.search.table.vouchers.refused',
          reimbursed: 'remittances.search.table.vouchers.reimbursed',
          toCorrect: 'remittances.search.table.vouchers.toCorrect',
        },
      },
      title: 'remittances.search.title',
    },
    searchHistory: {
      noImages: 'remittances.searchHistory.noImages',
      noResults: 'remittances.searchHistory.noResults',
    },
  },
  templates: {
    importWorkers: {
      BE_BRU: {
        acc: {
          csv: 'templates.importWorkers.BE_BRU.acc.csv',
          pdf: 'templates.importWorkers.BE_BRU.acc.pdf',
          xls: 'templates.importWorkers.BE_BRU.acc.xls',
          xlsx: 'templates.importWorkers.BE_BRU.acc.xlsx',
        },
        prod: {
          csv: 'templates.importWorkers.BE_BRU.prod.csv',
          pdf: 'templates.importWorkers.BE_BRU.prod.pdf',
          xls: 'templates.importWorkers.BE_BRU.prod.xls',
          xlsx: 'templates.importWorkers.BE_BRU.prod.xlsx',
        },
      },
      BE_VLG: {
        acc: {
          csv: 'templates.importWorkers.BE_VLG.acc.csv',
          pdf: 'templates.importWorkers.BE_VLG.acc.pdf',
          xls: 'templates.importWorkers.BE_VLG.acc.xls',
          xlsx: 'templates.importWorkers.BE_VLG.acc.xlsx',
        },
        prod: {
          csv: 'templates.importWorkers.BE_VLG.prod.csv',
          pdf: 'templates.importWorkers.BE_VLG.prod.pdf',
          xls: 'templates.importWorkers.BE_VLG.prod.xls',
          xlsx: 'templates.importWorkers.BE_VLG.prod.xlsx',
        },
      },
      BE_WAL: {
        acc: {
          csv: 'templates.importWorkers.BE_WAL.acc.csv',
          pdf: 'templates.importWorkers.BE_WAL.acc.pdf',
          xls: 'templates.importWorkers.BE_WAL.acc.xls',
          xlsx: 'templates.importWorkers.BE_WAL.acc.xlsx',
        },
        prod: {
          csv: 'templates.importWorkers.BE_WAL.prod.csv',
          pdf: 'templates.importWorkers.BE_WAL.prod.pdf',
          xls: 'templates.importWorkers.BE_WAL.prod.xls',
          xlsx: 'templates.importWorkers.BE_WAL.prod.xlsx',
        },
      },
    },
    importWorks: {
      BE_BRU: {
        acc: {
          csv: 'templates.importWorks.BE_BRU.acc.csv',
          pdf: 'templates.importWorks.BE_BRU.acc.pdf',
          xls: 'templates.importWorks.BE_BRU.acc.xls',
          xlsx: 'templates.importWorks.BE_BRU.acc.xlsx',
        },
        prod: {
          csv: 'templates.importWorks.BE_BRU.prod.csv',
          pdf: 'templates.importWorks.BE_BRU.prod.pdf',
          xls: 'templates.importWorks.BE_BRU.prod.xls',
          xlsx: 'templates.importWorks.BE_BRU.prod.xlsx',
        },
      },
      BE_VLG: {
        acc: {
          csv: 'templates.importWorks.BE_VLG.acc.csv',
          pdf: 'templates.importWorks.BE_VLG.acc.pdf',
          xls: 'templates.importWorks.BE_VLG.acc.xls',
          xlsx: 'templates.importWorks.BE_VLG.acc.xlsx',
        },
        prod: {
          csv: 'templates.importWorks.BE_VLG.prod.csv',
          pdf: 'templates.importWorks.BE_VLG.prod.pdf',
          xls: 'templates.importWorks.BE_VLG.prod.xls',
          xlsx: 'templates.importWorks.BE_VLG.prod.xlsx',
        },
      },
      BE_WAL: {
        acc: {
          csv: 'templates.importWorks.BE_WAL.acc.csv',
          pdf: 'templates.importWorks.BE_WAL.acc.pdf',
          xls: 'templates.importWorks.BE_WAL.acc.xls',
          xlsx: 'templates.importWorks.BE_WAL.acc.xlsx',
        },
        prod: {
          csv: 'templates.importWorks.BE_WAL.prod.csv',
          pdf: 'templates.importWorks.BE_WAL.prod.pdf',
          xls: 'templates.importWorks.BE_WAL.prod.xls',
          xlsx: 'templates.importWorks.BE_WAL.prod.xlsx',
        },
      },
    },
    relativeBankAccount: {
      BE_BRU: {
        acc: {
          pdf: 'templates.relativeBankAccount.BE_BRU.acc.pdf',
        },
        prod: {
          pdf: 'templates.relativeBankAccount.BE_BRU.prod.pdf',
        },
      },
      BE_VLG: {
        acc: {
          pdf: 'templates.relativeBankAccount.BE_VLG.acc.pdf',
        },
        prod: {
          pdf: 'templates.relativeBankAccount.BE_VLG.prod.pdf',
        },
      },
      BE_WAL: {
        acc: {
          pdf: 'templates.relativeBankAccount.BE_WAL.acc.pdf',
        },
        prod: {
          pdf: 'templates.relativeBankAccount.BE_WAL.prod.pdf',
        },
      },
    },
    voucherAnnouncement: {
      BE_BRU: {
        acc: {
          csv: 'templates.voucherAnnouncement.BE_BRU.acc.csv',
          xls: 'templates.voucherAnnouncement.BE_BRU.acc.xls',
          xlsx: 'templates.voucherAnnouncement.BE_BRU.acc.xlsx',
        },
        prod: {
          csv: 'templates.voucherAnnouncement.BE_BRU.prod.csv',
          xls: 'templates.voucherAnnouncement.BE_BRU.prod.xls',
          xlsx: 'templates.voucherAnnouncement.BE_BRU.prod.xlsx',
        },
      },
      BE_VLG: {
        acc: {
          csv: 'templates.voucherAnnouncement.BE_VLG.acc.csv',
          xls: 'templates.voucherAnnouncement.BE_VLG.acc.xls',
          xlsx: 'templates.voucherAnnouncement.BE_VLG.acc.xlsx',
        },
        prod: {
          csv: 'templates.voucherAnnouncement.BE_VLG.prod.csv',
          xls: 'templates.voucherAnnouncement.BE_VLG.prod.xls',
          xlsx: 'templates.voucherAnnouncement.BE_VLG.prod.xlsx',
        },
      },
      BE_WAL: {
        acc: {
          csv: 'templates.voucherAnnouncement.BE_WAL.acc.csv',
          xls: 'templates.voucherAnnouncement.BE_WAL.acc.xls',
          xlsx: 'templates.voucherAnnouncement.BE_WAL.acc.xlsx',
        },
        prod: {
          csv: 'templates.voucherAnnouncement.BE_WAL.prod.csv',
          xls: 'templates.voucherAnnouncement.BE_WAL.prod.xls',
          xlsx: 'templates.voucherAnnouncement.BE_WAL.prod.xlsx',
        },
      },
    },
  },
  tutorialVideoLink: {
    linkText: 'tutorialVideoLink.linkText',
    text: 'tutorialVideoLink.text',
  },
  tutorialVideos: {
    error: {
      videoNotLoaded: 'tutorialVideos.error.videoNotLoaded',
      videoTagNotSupported: 'tutorialVideos.error.videoTagNotSupported',
    },
    introduction: 'tutorialVideos.introduction',
    labels: {
      play: 'tutorialVideos.labels.play',
    },
    title: 'tutorialVideos.title',
    videoInfo: {
      details: {
        addSubsidiary: 'tutorialVideos.videoInfo.details.addSubsidiary',
        addWorker: 'tutorialVideos.videoInfo.details.addWorker',
        automaticRemittanceManagement:
          'tutorialVideos.videoInfo.details.automaticRemittanceManagement',
        changeProfileData: 'tutorialVideos.videoInfo.details.changeProfileData',
        changeRefundSettings:
          'tutorialVideos.videoInfo.details.changeRefundSettings',
        csvLayout: 'tutorialVideos.videoInfo.details.csvLayout',
        declarationFileImport:
          'tutorialVideos.videoInfo.details.declarationFileImport',
        extranetWebinar: 'tutorialVideos.videoInfo.details.extranetWebinar',
        extranetWebinar_copy:
          'tutorialVideos.videoInfo.details.extranetWebinar_copy',
        importWorkerList: 'tutorialVideos.videoInfo.details.importWorkerList',
        newExtranetWebinar:
          'tutorialVideos.videoInfo.details.newExtranetWebinar',
        pickupPlan: 'tutorialVideos.videoInfo.details.pickupPlan',
        remittanceEncoding:
          'tutorialVideos.videoInfo.details.remittanceEncoding',
        remittanceSlipCreation:
          'tutorialVideos.videoInfo.details.remittanceSlipCreation',
        searchAndExportModuleUsage:
          'tutorialVideos.videoInfo.details.searchAndExportModuleUsage',
        searchModuleUsage: 'tutorialVideos.videoInfo.details.searchModuleUsage',
        serviceEncoding: 'tutorialVideos.videoInfo.details.serviceEncoding',
        serviceExport: 'tutorialVideos.videoInfo.details.serviceExport',
        serviceImport: 'tutorialVideos.videoInfo.details.serviceImport',
        variousTips: 'tutorialVideos.videoInfo.details.variousTips',
        voucherValidityCheck:
          'tutorialVideos.videoInfo.details.voucherValidityCheck',
        xlsxLayout: 'tutorialVideos.videoInfo.details.xlsxLayout',
      },
      other: {
        explanationTutorial:
          'tutorialVideos.videoInfo.other.explanationTutorial',
      },
      summary: {
        explanationOfVideo:
          'tutorialVideos.videoInfo.summary.explanationOfVideo',
        extranetWebinarPresentation:
          'tutorialVideos.videoInfo.summary.extranetWebinarPresentation',
      },
      title: {
        electronicRemittances:
          'tutorialVideos.videoInfo.title.electronicRemittances',
        export: 'tutorialVideos.videoInfo.title.export',
        myCompany: 'tutorialVideos.videoInfo.title.myCompany',
        myServices: 'tutorialVideos.videoInfo.title.myServices',
        myWorkers: 'tutorialVideos.videoInfo.title.myWorkers',
        newExtranetWebinar: 'tutorialVideos.videoInfo.title.newExtranetWebinar',
        papersRemittances: 'tutorialVideos.videoInfo.title.papersRemittances',
        pickups: 'tutorialVideos.videoInfo.title.pickups',
        refunds: 'tutorialVideos.videoInfo.title.refunds',
        webinar: 'tutorialVideos.videoInfo.title.webinar',
      },
    },
  },
  visibility: {
    agreements: {
      DISABLED_PERSON_TRANSPORTATION:
        'visibility.agreements.DISABLED_PERSON_TRANSPORTATION',
      GROCERY_SHOPPING: 'visibility.agreements.GROCERY_SHOPPING',
      HOUSEKEEPING: 'visibility.agreements.HOUSEKEEPING',
      IRONING: 'visibility.agreements.IRONING',
      introduction: 'visibility.agreements.introduction',
      title: 'visibility.agreements.title',
    },
    locations: {
      addPostalCode: 'visibility.locations.addPostalCode',
      byPostalCodes: {
        subtitle: 'visibility.locations.byPostalCodes.subtitle',
        title: 'visibility.locations.byPostalCodes.title',
      },
      byRegionsAndProvinces: {
        antwerp: 'visibility.locations.byRegionsAndProvinces.antwerp',
        brussels: 'visibility.locations.byRegionsAndProvinces.brussels',
        eastFlanders: 'visibility.locations.byRegionsAndProvinces.eastFlanders',
        flanders: 'visibility.locations.byRegionsAndProvinces.flanders',
        flemishBrabant:
          'visibility.locations.byRegionsAndProvinces.flemishBrabant',
        hainaut: 'visibility.locations.byRegionsAndProvinces.hainaut',
        liege: 'visibility.locations.byRegionsAndProvinces.liege',
        limburg: 'visibility.locations.byRegionsAndProvinces.limburg',
        luxembourg: 'visibility.locations.byRegionsAndProvinces.luxembourg',
        namur: 'visibility.locations.byRegionsAndProvinces.namur',
        title: 'visibility.locations.byRegionsAndProvinces.title',
        wallonia: 'visibility.locations.byRegionsAndProvinces.wallonia',
        walloonBrabant:
          'visibility.locations.byRegionsAndProvinces.walloonBrabant',
        westFlanders: 'visibility.locations.byRegionsAndProvinces.westFlanders',
      },
      introduction: 'visibility.locations.introduction',
      title: 'visibility.locations.title',
      update: {
        errorMessage: 'visibility.locations.update.errorMessage',
        isSubmittingMessage: 'visibility.locations.update.isSubmittingMessage',
        successMessage: 'visibility.locations.update.successMessage',
      },
    },
  },
  vl: {
    brps: {
      label: 'vl.brps.label',
      url: 'vl.brps.url',
    },
    general: {
      emailAddress: 'vl.general.emailAddress',
      helpCenter: {
        phone: 'vl.general.helpCenter.phone',
      },
      region: {
        name: 'vl.general.region.name',
      },
      serviceVouchers: {
        helpCenter: {
          phoneNumber: 'vl.general.serviceVouchers.helpCenter.phoneNumber',
        },
        publicWebsite: {
          url: 'vl.general.serviceVouchers.publicWebsite.url',
        },
        website: {
          url: 'vl.general.serviceVouchers.website.url',
        },
      },
      url: {
        complaint: 'vl.general.url.complaint',
        contactUs: 'vl.general.url.contactUs',
        cookies: 'vl.general.url.cookies',
        faq: 'vl.general.url.faq',
        news: 'vl.general.url.news',
        privacyPolicy: 'vl.general.url.privacyPolicy',
        question: 'vl.general.url.question',
        termsAndConditions: 'vl.general.url.termsAndConditions',
        accountFrozenBlocked: 'vl.general.url.accountFrozenBlocked',
      },
    },
    header: {
      funcHeader: {
        cta: {
          backToInfoWebsite: {
            title: 'vl.header.funcHeader.cta.backToInfoWebsite.title',
          },
        },
      },
      support: {
        contactList: {
          callus: {
            description: 'vl.header.support.contactList.callus.description',
          },
        },
      },
    },
    login: {
      usefullLinks: {
        access: {
          label: 'vl.login.usefullLinks.access.label',
          url: 'vl.login.usefullLinks.access.url',
        },
        review: {
          label: 'vl.login.usefullLinks.review.label',
          url: 'vl.login.usefullLinks.review.url',
        },
      },
    },
    remittances: {
      reimbursement: {
        pdf: 'vl.remittances.reimbursement.pdf',
      },
    },
    siteBar: {
      title: 'vl.siteBar.title',
    },
  },
  wl: {
    brps: {
      label: 'wl.brps.label',
      url: 'wl.brps.url',
    },
    general: {
      emailAddress: 'wl.general.emailAddress',
      helpCenter: {
        phone: 'wl.general.helpCenter.phone',
      },
      region: {
        name: 'wl.general.region.name',
      },
      serviceVouchers: {
        helpCenter: {
          phoneNumber: 'wl.general.serviceVouchers.helpCenter.phoneNumber',
        },
        website: {
          url: 'wl.general.serviceVouchers.website.url',
        },
      },
      url: {
        complaint: 'wl.general.url.complaint',
        contactUs: 'wl.general.url.contactUs',
        cookies: 'wl.general.url.cookies',
        faq: 'wl.general.url.faq',
        news: 'wl.general.url.news',
        privacyPolicy: 'wl.general.url.privacyPolicy',
        question: 'wl.general.url.question',
        termsAndConditions: 'wl.general.url.termsAndConditions',
        accountFrozenBlocked: 'wl.general.url.accountFrozenBlocked',
      },
    },
    header: {
      support: {
        contactList: {
          callus: {
            description: 'wl.header.support.contactList.callus.description',
          },
        },
      },
    },
    remittances: {
      reimbursement: {
        pdf: 'wl.remittances.reimbursement.pdf',
      },
    },
    siteBar: {
      title: 'wl.siteBar.title',
    },
  },
  worker: {
    details: {
      active: {
        explanation: 'worker.details.active.explanation',
      },
      contract: {
        alert: {
          addContract: {
            message: 'worker.details.contract.alert.addContract.message',
          },
          body: 'worker.details.contract.alert.body',
          deleteContract: {
            message: 'worker.details.contract.alert.deleteContract.message',
          },
          title: 'worker.details.contract.alert.title',
          updateContract: {
            message: 'worker.details.contract.alert.updateContract.message',
          },
        },
        cta: {
          add: 'worker.details.contract.cta.add',
        },
        status: {
          CONTRACTED: 'worker.details.contract.status.CONTRACTED',
          INTEGRATION_INCOME_BENEFICIARY:
            'worker.details.contract.status.INTEGRATION_INCOME_BENEFICIARY',
          OTHER: 'worker.details.contract.status.OTHER',
          STUDENT_JOB: 'worker.details.contract.status.STUDENT_JOB',
          TEMPORARY_JOB: 'worker.details.contract.status.TEMPORARY_JOB',
          UNEMPLOYED_FULL_TIME_JOB_SEEKER:
            'worker.details.contract.status.UNEMPLOYED_FULL_TIME_JOB_SEEKER',
          UNEMPLOYED_PART_TIME_JOB_SEEKER:
            'worker.details.contract.status.UNEMPLOYED_PART_TIME_JOB_SEEKER',
        },
        table: {
          tableHead: {
            endDate: 'worker.details.contract.table.tableHead.endDate',
            establishmentNumber:
              'worker.details.contract.table.tableHead.establishmentNumber',
            startDate: 'worker.details.contract.table.tableHead.startDate',
            type: 'worker.details.contract.table.tableHead.type',
            workStatus: 'worker.details.contract.table.tableHead.workStatus',
          },
        },
        type: {
          FIXED: 'worker.details.contract.type.FIXED',
          PERMANENT: 'worker.details.contract.type.PERMANENT',
        },
      },
      cta: {
        edit: 'worker.details.cta.edit',
      },
      loginInformation: {
        tooltip: 'worker.details.loginInformation.tooltip',
      },
      title: 'worker.details.title',
    },
  },
  workers: {
    addWorker: {
      list: {
        title: 'workers.addWorker.list.title',
      },
      title: 'workers.addWorker.title',
    },
    cards: {
      addWorker: {
        cta: 'workers.cards.addWorker.cta',
        description: 'workers.cards.addWorker.description',
        list: {
          cta: 'workers.cards.addWorker.list.cta',
          description: 'workers.cards.addWorker.list.description',
        },
      },
    },
    details: {
      introduction: 'workers.details.introduction',
      title: 'workers.details.title',
    },
    downloadTemplate: {
      fileName: 'workers.downloadTemplate.fileName',
    },
    introduction: 'workers.introduction',
    label: {
      active: 'workers.label.active',
      all: 'workers.label.all',
      inactive: 'workers.label.inactive',
    },
    loginInformation: {
      blocked: 'workers.loginInformation.blocked',
      login: 'workers.loginInformation.login',
      modal: {
        resetPassword: {
          cta: 'workers.loginInformation.modal.resetPassword.cta',
          title: 'workers.loginInformation.modal.resetPassword.title',
        },
      },
      password: 'workers.loginInformation.password',
      resetPassword: {
        alert: {
          success: {
            message:
              'workers.loginInformation.resetPassword.alert.success.message',
          },
        },
        title: 'workers.loginInformation.resetPassword.title',
      },
      status: 'workers.loginInformation.status',
      title: 'workers.loginInformation.title',
    },
    modal: {
      addWorker: {
        confirmation: {
          alertMessage: 'workers.modal.addWorker.confirmation.alertMessage',
          alreadyExist: {
            alertMessage:
              'workers.modal.addWorker.confirmation.alreadyExist.alertMessage',
          },
        },
        subtitle: 'workers.modal.addWorker.subtitle',
      },
      export: {
        title: 'workers.modal.export.title',
      },
    },
    modals: {
      activateWorker: {
        cta: 'workers.modals.activateWorker.cta',
        title: 'workers.modals.activateWorker.title',
        worker: {
          error: 'workers.modals.activateWorker.worker.error',
          failure: 'workers.modals.activateWorker.worker.failure',
          success: 'workers.modals.activateWorker.worker.success',
        },
        workers: {
          error: 'workers.modals.activateWorker.workers.error',
          success: 'workers.modals.activateWorker.workers.success',
        },
      },
      addWorker: {
        confirmation: {
          alert: {
            error: {
              created:
                'workers.modals.addWorker.confirmation.alert.error.created',
              invalid:
                'workers.modals.addWorker.confirmation.alert.error.invalid',
              messageBottom:
                'workers.modals.addWorker.confirmation.alert.error.messageBottom',
              partial:
                'workers.modals.addWorker.confirmation.alert.error.partial',
              refused:
                'workers.modals.addWorker.confirmation.alert.error.refused',
              title: 'workers.modals.addWorker.confirmation.alert.error.title',
              updated:
                'workers.modals.addWorker.confirmation.alert.error.updated',
            },
            success: {
              message:
                'workers.modals.addWorker.confirmation.alert.success.message',
              messageBottom:
                'workers.modals.addWorker.confirmation.alert.success.messageBottom',
              title:
                'workers.modals.addWorker.confirmation.alert.success.title',
            },
          },
          downloadReport: {
            fileName:
              'workers.modals.addWorker.confirmation.downloadReport.fileName',
            generate:
              'workers.modals.addWorker.confirmation.downloadReport.generate',
            linkTitle:
              'workers.modals.addWorker.confirmation.downloadReport.linkTitle',
            title: 'workers.modals.addWorker.confirmation.downloadReport.title',
          },
        },
        cta: 'workers.modals.addWorker.cta',
        description: 'workers.modals.addWorker.description',
        list: {
          form: {
            labels: {
              newUpload: 'workers.modals.addWorker.list.form.labels.newUpload',
            },
            statusMessage: {
              error: 'workers.modals.addWorker.list.form.statusMessage.error',
            },
          },
          help: {
            step1: {
              title: 'workers.modals.addWorker.list.help.step1.title',
            },
            step2: {
              title: 'workers.modals.addWorker.list.help.step2.title',
            },
            step3: {
              title: 'workers.modals.addWorker.list.help.step3.title',
            },
            title: 'workers.modals.addWorker.list.help.title',
          },
          lastImport: {
            title: 'workers.modals.addWorker.list.lastImport.title',
          },
          processingImport: {
            content: 'workers.modals.addWorker.list.processingImport.content',
          },
          title: 'workers.modals.addWorker.list.title',
        },
        title: 'workers.modals.addWorker.title',
      },
      deactivateWorker: {
        cta: 'workers.modals.deactivateWorker.cta',
        title: 'workers.modals.deactivateWorker.title',
        worker: {
          failure: 'workers.modals.deactivateWorker.worker.failure',
          success: 'workers.modals.deactivateWorker.worker.success',
        },
        workers: {
          success: 'workers.modals.deactivateWorker.workers.success',
        },
      },
      editWorker: {
        alert: {
          successMessage: 'workers.modals.editWorker.alert.successMessage',
        },
        title: 'workers.modals.editWorker.title',
      },
    },
    search: {
      alert: {
        allContracted: {
          description: 'workers.search.alert.allContracted.description',
          title: 'workers.search.alert.allContracted.title',
        },
        description: 'workers.search.alert.description',
        link: 'workers.search.alert.link',
        title: 'workers.search.alert.title',
      },
      cta: {
        activateAll: 'workers.search.cta.activateAll',
        desactivateAll: 'workers.search.cta.desactivateAll',
      },
      form: {
        checkbox: {
          missingContract: 'workers.search.form.checkbox.missingContract',
        },
      },
      table: {
        head: {
          encodingLogin: 'workers.search.table.head.encodingLogin',
          workerContract: 'workers.search.table.head.workerContract',
        },
      },
      title: 'workers.search.title',
    },
    worksInformation: {
      cta: 'workers.worksInformation.cta',
      linkToHistory: 'workers.worksInformation.linkToHistory',
      subtitle: 'workers.worksInformation.subtitle',
      title: 'workers.worksInformation.title',
    },
  },
};
